import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service';
import '../../pages/OtherDocuments/OtherDocument.css';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal'
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useBack } from "use-back";
import { useSignalR } from '../../Contexts/signalR';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/saga-blue/theme.css';  // Optional: PrimeReact theme
import 'primereact/resources/primereact.min.css';           // PrimeReact CSS
import 'primeicons/primeicons.css';
import ClearIcon from '@mui/icons-material/Clear';
import AdvancedDropdown from '../../Components/AdvancedDropdown/AdvancedDropdown';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import '../Document/Document.scss';
import cs from './CollectionPage.module.scss';
import MergeIcon from '@mui/icons-material/Merge';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import AddNewCollectionItem from '../../Components/CollectionPage/AddNewCollectionItem';
import PaymentsExcelImportModal from '../../Components/CollectionPage/PaymentsExcelImportModal';
import MonthlyChargesExcelImportModal from '../../Components/CollectionPage/MonthlyChargesExcelImportModal';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import editIcon from '../../assests/images/Icons/editIcon.svg';
import PuffLoader from "react-spinners/PuffLoader";
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import ClientService from '../../Services/client.service.js';
import SubAccountantService from '../../Services/subAccountant.service.js'; 
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { motion, AnimatePresence } from 'framer-motion';
import MultipleDraftPdfPreview from '../../Components/Widgets/MultipleDraftPdfPreview/MultipleDraftPdfPreview';
import Swal from 'sweetalert2';
import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';
import DocumentService from '../../Services/documents.service.js';
import { Modal } from '@mui/material';        // ↞ add this next to the other MUI imports
import TaxAuthorityService from '../../Services/taxAuthority.service.js';
import { getIsraelInvoiceAmountLimit } from '../../Utils/GetIsraelInvoiceAmountLimit.js';
import Constants from '../../assests/Constants/constants.js';
import SignatureReferenceModal from '../../Components/Widgets/SignatureReferenceModal/SignatureReferenceModal.jsx';
import LedgerReportsModal from '../../Components/CollectionPage/LedgerReportsModal/LedgerReportsModal.jsx';
import ledgerReportsService from '../../Services/ledgerReports.service.js';
import MasavDraftModal from '../../Components/CollectionPage/MasavDraftModal/MasavDraftModal.jsx';
import MasavBulkReceiptModal, { MasavPaymentMethods } from '../../Components/CollectionPage/MasavBulkReceiptModal/MasavBulkReceiptModal.jsx';
import DocumentGenerationLogsModal from '../../Components/CollectionPage/DocumentGenerationLogsModal/DocumentGenerationLogsModal.jsx';
import MasavAccountantSettingsModal from '../../Components/CollectionPage/MasavAccountantSettingsModal/MasavAccountantSettingsModal.jsx';
import SavedCardsModal from '../../Components/CollectionPage/SavedCardsModal/SavedCardsModal.jsx';
import CreditCardBulkChargeModal from '../../Components/CollectionPage/CreditCardBulkChargeModal/CreditCardBulkChargeModal.jsx';
import PaymentArrangementsModal from '../../Components/CollectionPage/PaymentArrangementsModal/PaymentArrangementsModal.jsx';
import clientSavedCardsService from '../../Services/clientSavedCards.service.js';
import masavService from '../../Services/masav.service.js';
import MasavPaymentDayNotice, { useMasavPendingPaymentDays } from '../../Components/Widgets/MasavPaymentDayNotice/MasavPaymentDayNotice.jsx';
import creditTerminalService from '../../Services/creditTerminal.service.js';
import { getVatValue } from '../../Utils/GetVatValue';
//table imports
import { Edit as EditIcon, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon, DateRange as DateRangeIcon, OpenInFull as OpenInFullIcon, CloseFullscreen as CloseFullscreenIcon, EventBusy as EventBusyIcon } from '@mui/icons-material';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem,
    Menu, CircularProgress, LinearProgress, IconButton, Tooltip, FormControlLabel,
    Grid, Chip, Collapse, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs, { Dayjs } from 'dayjs';
import { beautifyNumber } from '../../Utils/FormatNumber';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styled from '@mui/system/styled';
import { keyframes } from '@emotion/react';
import UserAvatar from '../../Components/Widgets/UserAvatar/UserAvatar.js';
import CustomDatePicker from '../../Components/Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';
import TaxAuthorityErrorModal from '../../Components/TaxAuthorityErrorModal/TaxAuthorityErrorModal.jsx';
import { parseServerError } from '../../Utils/parseServerError.js';
import { formatLedgerInvoiceFailureDetails, translateLedgerInvoiceError } from '../../Utils/translateLedgerInvoiceError.js';
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});



setDefaultLocale('en-GB'); // Set the default locale to use it
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#304FFF',
});


const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 20px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E57C22',
    '&:hover': {
        backgroundColor: '#d9731a',
    },
});

const rowPulseKeyframes = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.85; }
`;

const XBTN_VARIANT = {
    primary: cs.btnPrimary,
    orange: cs.btnOrange,
    success: cs.btnSuccess,
    outline: cs.btnOutline,
    excel: cs.btnExcel,
};

/** Xtram-styled page button; `active` marks a toggled mode button. */
const XBtn = ({ variant = 'outline', active = false, icon = null, loading = false, className = '', children, ...rest }) => (
    <button
        type="button"
        className={[cs.btn, XBTN_VARIANT[variant], active ? cs.btnActive : '', className].filter(Boolean).join(' ')}
        {...rest}
    >
        {loading ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : icon}
        {children}
    </button>
);

const ExpandToggle = ({ expanded, onClick, t }) => (
    <Tooltip title={expanded ? t('Collapse', { defaultValue: 'כווץ' }) : t('Expand', { defaultValue: 'הרחב' })}>
        <span>
            <XBtn
                variant="outline"
                active={expanded}
                className={cs.btnIcon}
                onClick={onClick}
                icon={expanded ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
            />
        </span>
    </Tooltip>
);

const PaymentTypeOptions = [
    { name: "CreditCard", value: "0" },
    { name: "Check", value: "1" },
    { name: "BankTransfer", value: "2" },
    { name: "Cash", value: "3" }
];

/** True when the payment should be included in totals. If canceled (invoice/receipt/manual), its amount is not calculated. */
const isPaymentCountedInTotals = (payment) => {
    if (!payment) return false;
    const { invoiceIsCanceled = false, receiptIsCanceled = false, isCanceledManually = false } = payment;
    // Canceled → do not include this payment's amount in any total
    if (invoiceIsCanceled || receiptIsCanceled || isCanceledManually) return false;
    if (payment.isDisabled === true) return false;
    return Number(payment.amount) > 0;
};



const xtramScrollbarSx = {
    scrollbarWidth: 'var(--xtram-scrollbar-width, thin)',
    scrollbarColor: '#d8daf2 transparent',
    '&::-webkit-scrollbar': { width: '6px', height: '6px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { background: '#d8daf2', borderRadius: 'var(--xtram-radius-pill, 999px)' },
};

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    width: '100%',
    height: '10vh',
    border: 'none',
    fontFamily: 'var(--xtram-font)',
    '& .MuiAutocomplete-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"

    },
    '& *': {
        boxSizing: 'border-box !important',

    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#E3E7FE',
        minHeight: '42px !important',
        maxHeight: '42px !important',
        lineHeight: '42px',
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#E3E7FE',
        padding: '0 8px',
        minHeight: '42px !important',
        maxHeight: '42px !important',
        height: '42px !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#1222b3',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: 'normal',
    },
    '& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton': {
        color: '#1222b3',
    },
    '& .MuiDataGrid-main, & .MuiDataGrid-overlayWrapper': {
        backgroundColor: '#ffffff',
    },
    '& .MuiDataGrid-virtualScroller': {
        backgroundColor: '#ffffff',
        ...xtramScrollbarSx,
    },
    '& .MuiDataGrid-scrollbar': xtramScrollbarSx,
    '& .MuiDataGrid-toolbarContainer': {
        padding: '6px 8px',
        gap: '6px',
        borderBottom: '1px solid #eef0f8',
        '& .MuiButton-root': {
            color: '#304FFF',
            fontSize: '12px',
            textTransform: 'none',
            borderRadius: '8px',
        },
    },
    '& .MuiDataGrid-footerContainer': {
        borderTop: '1px solid #eef0f8',
        minHeight: '44px',
    },
    '& .MuiDataGrid-cell': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid #eef0f8',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        fontSize: '13px',
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(227, 230, 255, 0.3)',
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus': {
        outline: 'none',
    },
    '& .disableUser': {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    // New styles for edit mode
    '& .MuiDataGrid-cell--editing': {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell': {
        borderRight: 'none',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell:not(:last-child)': {
        borderRight: '8px solid transparent',
    },
    '& .MuiDataGrid-cell--editing': {
        padding: 0,
        backgroundColor: 'inherit',
    },
    '& .invoice-generated': {
        backgroundColor: 'rgba(152, 251, 152, 0.35)',   // light-green tint
        '&:hover': { backgroundColor: 'rgba(152, 251, 152, 0.55)' }, // a bit darker on hover
    },
    '& .receipt-generated': {
        backgroundColor: 'rgba(255, 255, 150, 0.4)',    // yellow tint
        '&:hover': { backgroundColor: 'rgba(255, 255, 150, 0.6)' },
    },
    '& .row-canceled': {
        backgroundColor: 'rgba(255, 180, 180, 0.5)',   // red tint for canceled invoice/receipt/manual
        '&:hover': { backgroundColor: 'rgba(255, 160, 160, 0.65)' },
    },
    '& .row-canceled-pulse': {
        backgroundColor: 'rgba(255, 180, 180, 0.5)',
        animation: `${rowPulseKeyframes} 1.5s ease-in-out infinite`,
        '&:hover': { backgroundColor: 'rgba(255, 160, 160, 0.65)' },
    },
}));

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#304FFF',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

const ActionButton = styled(Button)({
    backgroundColor: '#E57C22', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: 40, // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#d9731a', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});

// Add this styled FormControlLabel above the component
const StyledFormControlLabel = styled(FormControlLabel)(({ theme, getClosed }) => ({
    marginLeft: theme.spacing(2),
    '& *': {
        boxSizing: 'border-box !important',
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#E57C22',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#E57C22',
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#BFC8FF',
    },
    '& .MuiFormControlLabel-label': {
        fontWeight: 500,
        color: getClosed ? '#E57C22' : '#304FFF',
    },
}));

/** True when any of the five MASAV profile fields is empty (all-empty or partial — server resolves header from DB only). */
function isAccountantMasavBlockIncomplete(accountantUser) {
    if (!accountantUser) return false;
    const tr = (s) => (s ?? '').toString().trim();
    const vals = [
        tr(accountantUser.masavInstitutionSubjectCode),
        tr(accountantUser.masavSenderInstitutionCode),
        tr(accountantUser.masavInstitutionName),
        tr(accountantUser.masavBeneficiaryAccountType),
        tr(accountantUser.masavHeaderSerial),
    ];
    return !vals.every(Boolean);
}

function CollectionPage() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [documentTypeFetch, setDocumentTypeFetch] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isClientDataFetched, setIsClientDataFetched] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'cardId', direction: 'descending', type: 'number' });
    const [focused, setFocused] = useState(false);
    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();
    const [calculatedWidth, setCalculatedWidth] = useState('70%');
    const { goBack } = useContext(NavHistoryContext);
    const [selectedCaseIds, setSelectedCaseIds] = useState([]);   // client filter
    // Payment action mode: which rows can be selected (receipt = no receipt, invoice = no invoice, close = open rows)
    const [paymentActionMode, setPaymentActionMode] = useState(null); // null | 'receipt' | 'invoice' | 'close'
    const [pickedPayments, setPickedPayments] = useState([]);     // chosen rows
    const [lastPickedPayments, setLastPickedPayments] = useState([]);
    const [isClosing, setIsClosing] = useState(false);
    const [invoiceGenDate, setInvoiceGenDate] = useState(null);
    const [clientSelectError, setClientSelectError] = useState(false);
    const [paymentMenuAnchor, setPaymentMenuAnchor] = useState(null);
    const [paymentMenuRow, setPaymentMenuRow] = useState(null);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);

    /* ---------- invoice drafts preview ---------- */
    const [pdfResults, setPdfResults] = useState([]); // [{fileName,pdfBase64}]
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewKind, setPreviewKind] = useState('invoice'); // 'invoice' | 'receipt'
    const [receiptBulkJobs, setReceiptBulkJobs] = useState([]); // [{ caseId, paymentIds, receiptDate, clientName, amount }]
    /** True while GenerateLedgerInvoicesDraft is in flight (separate from final invoice generation). */
    const [isDraftingLedgerInvoices, setIsDraftingLedgerInvoices] = useState(false);
    /** True while receipt draft bulk / single draft API is in flight. */
    const [isDraftingReceiptDrafts, setIsDraftingReceiptDrafts] = useState(false);
    const [pdfIndex, setPdfIndex] = useState(0);
    const [blobUrl, setBlobUrl] = useState('');
    const [slideDirection, setSlideDirection] = useState(1);
    const [isGenerating, setIsGenerating] = useState(false);
    /** True while a bulk/single receipt generation (final or draft) API call is in flight. */
    const [isGeneratingReceipts, setIsGeneratingReceipts] = useState(false);
    const [draftPdfModalVisible, setDraftPdfModalVisible] = useState(false);
    const [draftPdfBlob, setDraftPdfBlob] = useState(null);
    const [receiptDraftQueue, setReceiptDraftQueue] = useState([]); // [{ blob, caseId, paymentIds, reference }]
    const [currentReceiptDraftReference, setCurrentReceiptDraftReference] = useState(null);


    /* ---------- tax-authority one-time auth ---------- */
    const [resumeInvoicesGeneration, setResumeInvoicesGeneration] = useState(false);
    const [authWindow, setAuthWindow] = useState(null);

    /* ───────── tax authority error modal ───────── */
    const [isTaxAuthorityErrorModalVisible, setIsTaxAuthorityErrorModalVisible] = useState(false);

    /* ───────── signature / reference modal ───────── */
    const [sigRefModalOpen, setSigRefModalOpen] = useState(false);
    const [needSig, setNeedSig] = useState(false);
    const [needRef, setNeedRef] = useState(false);
    const [invoiceSignature, setInvoiceSignature] = useState(null);
    const [invoiceReference, setInvoiceReference] = useState(null);
    const pendingAction = useRef(null);     // remembers what we should run after the modal

    /* ───────── ledger reports modal ───────── */
    const [ledgerReportsModalOpen, setLedgerReportsModalOpen] = useState(false);
    const [generationLogsModalOpen, setGenerationLogsModalOpen] = useState(false);
    const [masavDraftModalOpen, setMasavDraftModalOpen] = useState(false);
    const [paymentsExcelImportModalOpen, setPaymentsExcelImportModalOpen] = useState(false);
    const [monthlyChargesImportModalOpen, setMonthlyChargesImportModalOpen] = useState(false);
    const [masavBulkReceiptOpen, setMasavBulkReceiptOpen] = useState(false);
    const [masavBulkReceiptRows, setMasavBulkReceiptRows] = useState([]);
    const [masavBulkReceiptSubmitting, setMasavBulkReceiptSubmitting] = useState(false);
    /** { batchId } when the bulk receipt was opened from a saved MASAV batch (rows are tracked on it). */
    const [masavBatchContext, setMasavBatchContext] = useState(null);
    const [masavProfileModalOpen, setMasavProfileModalOpen] = useState(false);
    const [pendingAfterMasavProfileSave, setPendingAfterMasavProfileSave] = useState(null);
    const [masavDraftReloadNonce, setMasavDraftReloadNonce] = useState(0);
    const [savedCardsModalOpen, setSavedCardsModalOpen] = useState(false);
    /** When set, opens SavedCardsModal in single-client mode for this case id. */
    const [savedCardsForceCaseId, setSavedCardsForceCaseId] = useState(null);
    /** Dedicated credit-card bulk charge modal (separate from MASAV). */
    const [creditCardChargeOpen, setCreditCardChargeOpen] = useState(false);
    const [paymentArrangementsModalOpen, setPaymentArrangementsModalOpen] = useState(false);
    /**
     * Accountant credit-terminal status. We only expose the "Charge via credit card"
     * and "Manage saved cards" affordances when the accountant has an approved
     * terminal (Tranzila or Grow) — otherwise charging / tokenizing would always fail.
     * capabilities.supportsRawPanDebit is false on Grow: typing card numbers is
     * disabled there and tokens come from payment links with save-card consent.
     * Shape: { exists: bool, status: int, capabilities: {...} }  (status === 1 → approved).
     */
    const [creditTerminalStatus, setCreditTerminalStatus] = useState(null);
    const creditTerminalApproved = !!(creditTerminalStatus?.exists && creditTerminalStatus?.status === 1);
    useEffect(() => {
        let cancelled = false;
        creditTerminalService
            .status()
            .then((s) => { if (!cancelled) setCreditTerminalStatus(s || null); })
            .catch((e) => {
                // Most accountants simply have no terminal — hide the CC buttons quietly,
                // but keep a trace for debugging real API failures.
                console.warn('CreditTerminal status load failed:', e?.message || e);
                if (!cancelled) setCreditTerminalStatus(null);
            });
        return () => { cancelled = true; };
    }, []);
    /** Per-row charge state during a CC bulk receipt run. caseId → 'pending'|'success'|'failed'. */
    const [masavCcChargeProgress, setMasavCcChargeProgress] = useState({});
    /** When non-empty, MASAV draft/file is limited to these collection-page client filter case IDs. */
    const masavFilterCaseIds = useMemo(
        () =>
            selectedCaseIds.length > 0 ? selectedCaseIds.map((v) => String(v.value)) : undefined,
        [selectedCaseIds]
    );
    /**
     * Returns { needSig, needRef } for the requested document type.
     *  – docType = 'invoice'  →  use taxInvoiceReference (default 0)
     *  – docType = 'receipt'  →  use receiptReference   (default 0)
     *
     * The reference is only requested when the server-side reference value for
     * the document type is still at its default ("untouched") value. Once the
     * user customizes it, we never ask for a reference again. The signature is
     * requested whenever the client has none on file.
     */
    const getReferenceKeyAndDefault = (docType) => {
        if (docType === 'invoice') return { key: 'taxInvoiceReference', default: 0 };
        return { key: 'receiptReference', default: 0 };
    };

    const signatureChecklist = async (docType) => {
        if (!client) return { needSig: false, needRef: false };

        const hasSignature = Boolean(client.signature);
        let referencesAreDefault = false;

        try {
            const referencesResponse = await DocumentService.GetReferenceByCaseId(client.caseId, token);
            if (referencesResponse.success && referencesResponse.data) {
                const refInfo = getReferenceKeyAndDefault(docType);
                referencesAreDefault = referencesResponse.data[refInfo.key] === refInfo.default;
            }
        } catch (error) {
            console.error('Error fetching references:', error);
            referencesAreDefault = true; // Assume default if fetch fails
        }

        if (referencesAreDefault) {
            return { needSig: !hasSignature, needRef: true };
        }

        return { needSig: !hasSignature, needRef: false };
    };



    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);
    //account cards


    useEffect(() => {
        if (selectedCaseIds.length) setClientSelectError(false);
    }, [selectedCaseIds]);


    const fileInputRef1 = useRef(null); // Reference to the first hidden file input
    const isFetchingRef = useRef(false);



    const handleFileChange = (event, uploadFunction) => {
        const file = event.target.files[0];
        if (file) {
            uploadFunction(file); // Call the passed upload function with the selected file
        }
    };

    const handleFileButtonClick = (fileInputRef, uploadFunction) => {
        // Reset the file input value
        fileInputRef.current.value = '';

        // Set up the onchange event handler
        fileInputRef.current.onchange = (event) => handleFileChange(event, uploadFunction);

        // Trigger the file input click
        fileInputRef.current.click();
    };

    const handleTaxAuthorityAuth = (authUrl) => {
        const w = window.open(authUrl, '_blank');
        setAuthWindow(w);
        checkAuthCompletion(w);
    };

    const checkAuthCompletion = async (w) => {
        let tries = 0;
        const MAX = 25;              // ~75 s
        try {
            while (tries < MAX) {
                if (w.closed) {
                    toast.error(t('Authentication window was closed by the user.'));
                    return;
                }
                const res = await TaxAuthorityService.checkAuthCompletionClient(client.caseId, Constants.TaxAuthorityScopes.CreationNumber);
                if (res.completed) {
                    if (!w.closed) w.close();
                    setResumeInvoicesGeneration(true);
                    return;
                }
                tries++;
                await new Promise(r => setTimeout(r, 3000));
            }
            toast.error(t('tokenFetchError'));
            if (!w.closed) w.close();
        } catch (err) {
            console.error(err);
            toast.error(t('tokenFetchError'));
            if (!w.closed) w.close();
        }
    };

    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const synchronizeScroll = () => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = tableContainerRef.current.scrollLeft;

        }
    };

    const [collectionPageData, setCollectionPageData] = useState({});
    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });;

    // Date filter toggle states (like Assignments)
    const [dateFilterMode, setDateFilterMode] = useState('tillDate'); // 'tillDate' or 'monthOnly'
    const [filterMonth, setFilterMonth] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    });
    const [endDateFilter, setEndDateFilter] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 0);
    });
    
    // Payments table expansion
    const [expandedTable, setExpandedTable] = useState(null); // null | 'monthly' | 'oneTime' | 'payments'
    const toggleExpandedTable = (key) => setExpandedTable((prev) => (prev === key ? null : key));
    const isTableVisible = (key) => !expandedTable || expandedTable === key;

    // ---- helper: flattenBulk (put with the imports) -------------------
    const flattenBulk = (bulk) => {
        if (!bulk) return {
            monthlyCharges: [], oneTimeCharges: [], payments: [], balance: 0,
            totalPayments: 0, totalOneTimeCharges: 0, totalMonthlyCharges: 0, grandTotal: 0
        };

        const flatten = (dict) =>
            Object.entries(dict || {}).flatMap(([caseId, arr]) =>
                (arr || []).map((row) => ({ ...row, caseId }))   // << keeps caseId
            );

        return {
            monthlyCharges: flatten(bulk.monthlyCharges),
            oneTimeCharges: flatten(bulk.oneTimeCharges),
            payments: flatten(bulk.payments),
            balance: Object.values(bulk.balances || {}).reduce((s, v) => s + v, 0),
            // Include totals from backend
            totalPayments: bulk.totalPayments || 0,
            totalOneTimeCharges: bulk.totalOneTimeCharges || 0,
            totalMonthlyCharges: bulk.totalMonthlyCharges || 0,
            grandTotal: bulk.grandTotal || 0,
        };
    };

    const openDraftPdfModal = (blob) => { setDraftPdfBlob(blob); setDraftPdfModalVisible(true); };
    const openQueuedReceiptDraft = (entry) => {
        if (!entry?.blob) return;
        setIsFinalReciept(!!entry.isFinal);
        setIsMultiplePayments(true);
        setMultiplePaymentIds(entry.paymentIds || []);
        setSelectedClientCaseId(entry.caseId || null);
        setCurrentReceiptDraftReference(entry.reference || null);
        openDraftPdfModal(entry.blob);
    };
    const handleCloseDraftPdf = () => { 
        setDraftPdfBlob(null); 
        setDraftPdfModalVisible(false); 
        setIsMultiplePayments(false);
        setMultiplePaymentIds([]);
        setSelectedClientCaseId(null);
        setCurrentReceiptDraftReference(null);
        setIsFinalReciept(false);

        // For MASAV bulk flow, continue to next queued draft in the same modal UX.
        if (receiptDraftQueue.length > 0) {
            const [next, ...rest] = receiptDraftQueue;
            setReceiptDraftQueue(rest);
            setTimeout(() => openQueuedReceiptDraft(next), 0);
        }
    };

    const [docFilter, setDocFilter] = useState('');
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('all');

    // Helper function to parse date string as UTC
    const parseDateAsUTC = (dateString) => {
        if (!dateString) return null;
        // If date string doesn't have timezone info (Z, +HH:MM, or -HH:MM), treat it as UTC
        const hasTimezone = dateString.endsWith('Z') || 
                           /[+-]\d{2}:\d{2}$/.test(dateString) ||
                           /[+-]\d{4}$/.test(dateString);
        if (!hasTimezone) {
            return new Date(dateString + 'Z');
        }
        return new Date(dateString);
    };

    const calculateWholeMonthsInRange = (startDate, endDate) => {
        // Parse dates as UTC
        const start = new Date(startDate);
        const end = new Date(endDate);
        
        // Use UTC methods for consistent calculation (matching C# implementation)
        const startYear = start.getUTCFullYear();
        const startMonth = start.getUTCMonth() + 1; // C# months are 1-based
        
        const endYear = end.getUTCFullYear();
        const endMonth = end.getUTCMonth() + 1; // C# months are 1-based
        
        // Match C# formula: ((endDate.Year - startDate.Year) * 12) + endDate.Month - startDate.Month + 1
        let months = ((endYear - startYear) * 12) + endMonth - startMonth + 1;
        
        // Return 1 if months is zero (matching C# logic)
        return months === 0 ? 1 : months;
    };

    const filteredData = useMemo(() => {
        // start with originals
        let m = collectionPageData.monthlyCharges || [];
        let o = collectionPageData.oneTimeCharges || [];
        let p = collectionPageData.payments || [];

        // filter by selected clients
        if (client?.leadingBusiness && selectedCaseIds.length) {
            const ids = selectedCaseIds.map((v) => v.value);
            const keep = (row) => ids.includes(row.caseId);
            m = m.filter(keep);
            o = o.filter(keep);
            p = p.filter(keep);
        }

        // filter by search text (description / reference / amount)
        if (searchQuery.trim()) {
            const q = searchQuery.toLowerCase();
            const match = (row) =>
                Object.values(row)
                    .join(' ')
                    .toLowerCase()
                    .includes(q);
            m = m.filter(match);
            o = o.filter(match);
            p = p.filter(match);
        }

        if (docFilter !== "") {
            const byDoc = (row) => {
                switch (docFilter) {
                    case 'invoice':
                        return !!row.invoiceId && !row.receiptId;
                    case 'receipt':
                        return !!row.receiptId && !row.invoiceId;
                    case 'none':
                        return !row.invoiceId && !row.receiptId;
                    default:       // 'all'
                        return true;
                }
            };
            p = p.filter(byDoc);
        }

        // Filter payments based on payment status filter
        if (paymentStatusFilter !== 'all') {
            if (paymentStatusFilter === 'open') {
                p = p.filter(row => !row.isClosed);
            } else if (paymentStatusFilter === 'closed') {
                p = p.filter(row => row.isClosed);
            }
        }

        return { m, o, p };
    }, [collectionPageData, selectedCaseIds, searchQuery, client?.leadingBusiness, docFilter, paymentStatusFilter]);

    // Use totals from backend response
    const summaryTotals = useMemo(() => {
        // For single client (regular client), use filtered data so summary matches the table (search, doc filter, payment status)
        if (!client?.leadingBusiness) {
            const payments = filteredData.p || [];
            const oneTimeCharges = filteredData.o || [];
            const monthlyCharges = filteredData.m || [];

            // Calculate one-time charges total
            const oneTimeChargesTotal = oneTimeCharges.reduce((sum, charge) => sum + (charge.amount || 0), 0);
            
            // Calculate payments total (exclude disabled, negative, canceled) (exclude canceled payments – they count as no payment)
            const nonCanceledPayments = payments.filter(p => !(p.invoiceIsCanceled || p.receiptIsCanceled || p.isCanceledManually));
            const paymentsTotal = nonCanceledPayments
                .filter(isPaymentCountedInTotals)
                .reduce((sum, payment) => sum + (payment.amount || 0), 0);
            console.log('paymentsTotal', paymentsTotal);
            // Calculate monthly charges total based on filter mode
            let monthlyChargesTotal = 0;
            if (dateFilterMode === 'monthOnly') {
                // Month Only mode: each active charge counts as 1 month
                monthlyCharges.forEach(monthlyCharge => {
                    monthlyChargesTotal += (monthlyCharge.amount || 0);
                });
            } else {
                // Till Date mode: calculate based on whole months
                // When charge has no endDate (continuing), use filter end: last day of filterMonth (monthOnly) or endDateFilter (tillDate)
                const filterEndDate = dateFilterMode === 'monthOnly'
                    ? new Date(Date.UTC(filterMonth.getUTCFullYear(), filterMonth.getUTCMonth() + 1, 0))  // last day of filter month
                    : new Date(Date.UTC(endDateFilter.getUTCFullYear(), endDateFilter.getUTCMonth(), endDateFilter.getUTCDate())); // endDateFilter (tillDate)
                monthlyCharges.forEach(monthlyCharge => {
                    const startDate = parseDateAsUTC(monthlyCharge.startDate);
                    const chargeEndDate = monthlyCharge.endDate != null ? parseDateAsUTC(monthlyCharge.endDate) : null;
                    // Continuing charge (null endDate) or charge ends after filter range → use filter end
                    const endDateForCalculation = !chargeEndDate || chargeEndDate > filterEndDate ? filterEndDate : chargeEndDate;
                    const monthsActive = calculateWholeMonthsInRange(startDate, endDateForCalculation);
                    monthlyChargesTotal += monthsActive * (monthlyCharge.amount || 0);
                });
            }
            
            // Calculate grand total using the same logic as C# CalculateLedgerBalance
            let grandTotal = 0;
            grandTotal -= oneTimeChargesTotal; // Subtract one-time charges
            grandTotal += paymentsTotal; // Add payments
            grandTotal -= monthlyChargesTotal; // Subtract monthly charges
            
            return {
                monthlyCharges: monthlyChargesTotal,
                oneTimeCharges: oneTimeChargesTotal,
                payments: paymentsTotal,
                total: grandTotal
            };
        }
        
        // For leading business, use backend totals
        return {
            monthlyCharges: collectionPageData.totalMonthlyCharges || 0,
            oneTimeCharges: collectionPageData.totalOneTimeCharges || 0,
            payments: collectionPageData.totalPayments || 0,
            total: collectionPageData.grandTotal || 0
        };
    }, [collectionPageData, client?.leadingBusiness, dateFilterMode, filterMonth, endDateFilter, filteredData]);

    const docFilterOptions = useMemo(
        () => [
            { value: 'invoice', label: t('InvoiceOnly') },   // ➜ "חשבונית בלבד" etc.
            { value: 'receipt', label: t('ReceiptOnly') },   // ➜ "קבלה בלבד"
            { value: 'none', label: t('NoneDocument') },          // ➜ "ללא מסמך"
        ],
        [t]
    );

    // Payment status filter options
    const paymentStatusFilterOptions = useMemo(
        () => [
            { value: 'open', label: t('openPayments') },
            { value: 'closed', label: t('ClosedPayments') },
            { value: 'all', label: t('AllPayments') },
        ],
        [t]
    );

    // Calculate balance using the same logic as C# CalculateLedgerBalance method
    const computedBalance = useMemo(() => {
        // For single client, use the original balance calculation
        if (!client?.leadingBusiness) {
            return collectionPageData.balance || 0;
        }
        
        // For leading business with multiple clients, calculate based on selected clients
        let balance = 0;
        
        // Get all data (respecting payment status filter); exclude canceled payments from calculations
        const rawPayments = collectionPageData.payments || [];
        const allPayments = rawPayments.filter(p => !(p.invoiceIsCanceled || p.receiptIsCanceled || p.isCanceledManually));
        const payments = paymentStatusFilter === 'all' ? allPayments : 
                        paymentStatusFilter === 'closed' ? allPayments.filter(p => p.isClosed) :
                        allPayments.filter(p => !p.isClosed);
        
        const oneTimeCharges = collectionPageData.oneTimeCharges || [];
        const monthlyCharges = collectionPageData.monthlyCharges || [];
        
        // If specific clients are selected, filter by them
        if (selectedCaseIds.length > 0) {
            const selectedCaseIdsArray = selectedCaseIds.map(v => v.value);
            
            // Filter payments by selected clients
            const filteredPayments = payments.filter(p => selectedCaseIdsArray.includes(p.caseId));
            
            // Filter charges by selected clients
            const filteredOneTimeCharges = oneTimeCharges.filter(c => selectedCaseIdsArray.includes(c.caseId));
            const filteredMonthlyCharges = monthlyCharges.filter(c => selectedCaseIdsArray.includes(c.caseId));
            
            // Calculate balance using C# logic
            // Subtract one-time charges
            const totalOneTimeCharges = filteredOneTimeCharges.reduce((sum, charge) => sum + (charge.amount || 0), 0);
            balance -= totalOneTimeCharges;
            
            // Add payments (exclude disabled, negative, canceled) (canceled already excluded above)
            const totalPayments = filteredPayments
                .filter(isPaymentCountedInTotals)
                .reduce((sum, payment) => sum + (payment.amount || 0), 0);
            balance += totalPayments;
            
            // Subtract monthly charges based on filter mode
            if (dateFilterMode === 'monthOnly') {
                // Month Only mode: each active charge counts as 1 month
            filteredMonthlyCharges.forEach(monthlyCharge => {
                    balance -= (monthlyCharge.amount || 0);
                });
            } else {
                // Till Date mode: calculate based on whole months
                // When charge has no endDate (continuing), use filter end: last day of filterMonth (monthOnly) or endDateFilter (tillDate)
                const filterEndDate = dateFilterMode === 'monthOnly'
                    ? new Date(Date.UTC(filterMonth.getUTCFullYear(), filterMonth.getUTCMonth() + 1, 0))  // last day of filter month
                    : new Date(Date.UTC(endDateFilter.getUTCFullYear(), endDateFilter.getUTCMonth(), endDateFilter.getUTCDate())); // endDateFilter (tillDate)
                filteredMonthlyCharges.forEach(monthlyCharge => {
                    const startDate = parseDateAsUTC(monthlyCharge.startDate);
                    const chargeEndDate = monthlyCharge.endDate != null ? parseDateAsUTC(monthlyCharge.endDate) : null;
                    // Continuing charge (null endDate) or charge ends after filter range → use filter end
                    const endDateForCalculation = !chargeEndDate || chargeEndDate > filterEndDate ? filterEndDate : chargeEndDate;
                    const monthsActive = calculateWholeMonthsInRange(startDate, endDateForCalculation);
                    balance -= monthsActive * (monthlyCharge.amount || 0);
                });
            }
        } else {
            // For all clients, use the flattened balance from the API
            balance = collectionPageData.balance || 0;
        }
        
        return balance;
    }, [collectionPageData, paymentStatusFilter, selectedCaseIds, client?.leadingBusiness, dateFilterMode, filterMonth, endDateFilter]);
    
    // Helper function to calculate whole months in range (similar to C# CalculateWholeMonthsInRange)

    const [minimalClientData, setMinimalClientData] = useState([]);



    // inside CollectionPage component
    const fetchEnums = async (user, token, client, filterStartDate = null, filterEndDate = null, overrideFilterMode = null, overrideFilterMonth = null, overrideEndDateFilter = null) => {
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;

        setCollectionPageData({});
        setLoading(true);

        try {
            const cutoff = new Date(endDate.getFullYear(), endDate.getMonth(), 25);

            const currentFilterMode = overrideFilterMode !== null ? overrideFilterMode : dateFilterMode;
            const currentFilterMonth = overrideFilterMonth !== null ? overrideFilterMonth : filterMonth;
            const currentEndDateFilter = overrideEndDateFilter !== null ? overrideEndDateFilter : endDateFilter;

            const filterParams = {
                filterMode: currentFilterMode,
                filterStartDate: currentFilterMode === 'monthOnly' ? currentFilterMonth : null,
                filterEndDate: currentFilterMode === 'tillDate' ? currentEndDateFilter : (currentFilterMode === 'monthOnly' ? currentFilterMonth : null)
            };

            let data;

            /* ───── ACCOUNTANT WITH MANY CLIENTS ───── */
            if (client.leadingBusiness) {
                let dataResp;
                if (selectedCaseIds.length) {
                    const ids = selectedCaseIds.map(v => v.value);
                    const [listResult, resp] = await Promise.all([
                        ClientService.GetAllClientNames(client.accountantId, token),
                        EnumsService.GetCollectionPageBulk(
                            ids, token, cutoff, false,
                            filterParams.filterMode, filterParams.filterStartDate, filterParams.filterEndDate,
                            true
                        )
                    ]);
                    setMinimalClientData(listResult);
                    dataResp = resp;
                } else {
                    const [listResult, resp] = await Promise.all([
                        ClientService.GetAllClientNames(client.accountantId, token),
                        EnumsService.GetCollectionPageForAllAccountantClients(
                            client.accountantId, token, cutoff, false,
                            filterParams.filterMode, filterParams.filterStartDate, filterParams.filterEndDate,
                            true
                        )
                    ]);
                    setMinimalClientData(listResult);
                    dataResp = resp;
                }

                if (!dataResp.ok) throw new Error('bulk failed');
                data = flattenBulk(await dataResp.json());
            }

            /* ───── SINGLE-CASE CLIENT ───── */
            else {
                const resp = await EnumsService.GetCollectionPage(
                    client.caseId,
                    token,
                    cutoff,
                    filterParams.filterMode,
                    filterParams.filterStartDate,
                    filterParams.filterEndDate
                );
                if (!resp.ok) throw new Error('single failed');
                data = await resp.json();
            }

            setCollectionPageData(data);
            setIsClientDataFetched(true);
        } catch (err) {
            console.error(err);
            toast.error(t('FailedToGetCollectionPage'));
            setIsClientDataFetched(false);
        } finally {
            setLoading(false);
            isFetchingRef.current = false;
        }
    };


    // case ids to option convertion
    const caseIdOptions = useMemo(
        () =>
            minimalClientData.map((c) => ({
                value: c.caseId,
                label: c.name,
            })),
        [minimalClientData]
    );

    // Fetch leading business caseId
    const fetchLeadingBusinessCaseId = async (accountantId, token) => {
        try {
            const response = await ClientService.GetLeadingBusinessCaseId(accountantId, token);
            if (response.ok) {
                const data = await response.json();
                if (data.success && data.data) {
                    setLeadingBusinessCaseId(data.data.caseId);
                }
            }
        } catch (error) {
            console.error('Error fetching leading business caseId:', error);
        }
    };




    const [idToDelete, setIdToDelete] = useState('');
    const handleDeleteItem = async () => {
        const id = idToDelete;
        try {
            let response;
            switch (itemType) {
                case 'monthlyCharges':
                    response = await EnumsService.DeleteMonthlyCharge(id, token);
                    break;
                case 'oneTimeCharges':
                    response = await EnumsService.DeleteOneTimeCharge(id, token);
                    break;
                case 'payments':
                    response = await EnumsService.DeletePayment(id, token);
                    break;
                default:
                    toast.error("Invalid item type.");
                    return;
            }

            if (response.ok) {
                toast.success(t('ItemDeletedSuccessfully'));
                await fetchEnums(user, token, client, null, null); // Refresh data after editing
                setDialogOpen(false); // Close the dialog after successful deletion
                setDeleteModalVisable(false)
            } else {
            }
        } catch (error) {
            console.error("Error deleting item:", error);
            toast.error("An error occurred while deleting the item");
        }
    };


    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (!currentUser || !currentToken) {
                    navigate("/login");
                    return;
                }

                setUser(currentUser);
                setToken(currentToken);

                const navClient = location.state?.client;
                if (location.state && navClient && location.state.type) {
                    setType(location.state.type);
                    setClient(navClient);
                }

                const parallel = [
                    fetchEnums(currentUser, currentToken, navClient, null, null),
                ];

                if (navClient?.accountantId) {
                    parallel.push(
                        fetchLeadingBusinessCaseId(navClient.accountantId, currentToken),
                        loadSubAccountantData(currentUser, currentToken, navClient),
                    );
                }

                await Promise.all(parallel);
            } catch (error) {
                console.error(error);
            }
            setLoading(false);
        };
        fetchUserData();
    }, [location.state.client]);

    const loadSubAccountantData = async (currentUser, currentToken, currentClient) => {
        try {
            const [result2, accountantResult] = await Promise.all([
                SubAccountantService.GetSubAccountantByAccountantId(currentToken, currentUser.accountantId),
                SubAccountantService.GetAccountantById(currentToken, currentUser.accountantId),
            ]);
            const enhancedAccountant = {
                ...accountantResult,
                subAccountantId: accountantResult.accountantId,
            };
            const combined = [enhancedAccountant, ...(result2 || [])];
            if (currentClient?.caseId) {
                combined.push({ subAccountantId: currentClient.caseId, name: currentClient.name });
            }
            setSubAccountantOptions(combined.map(acc => ({ value: acc.subAccountantId, label: acc.name })));
        } catch (_) {
            setSubAccountantOptions([]);
        }
    };

    const handleMasavProfileSaved = (updated) => {
        if (updated) setUser(updated);
        setMasavProfileModalOpen(false);
        const pending = pendingAfterMasavProfileSave;
        setPendingAfterMasavProfileSave(null);
        if (pending === 'openDraft') setMasavDraftModalOpen(true);
        if (pending === 'refreshDraft') setMasavDraftReloadNonce((n) => n + 1);
    };

    const handleMasavProfileModalClose = () => {
        setMasavProfileModalOpen(false);
        setPendingAfterMasavProfileSave(null);
    };

    const handleGenerateMasavClick = async () => {
        try {
            const userType = await UserService.getCurrentUserType();
            if (Number(userType) === 2 && isAccountantMasavBlockIncomplete(user)) {
                setPendingAfterMasavProfileSave('openDraft');
                setMasavProfileModalOpen(true);
                return;
            }
        } catch (_) {
            /* ignore */
        }
        setMasavDraftModalOpen(true);
    };

    const handleOpenMasavProfileSettingsFromDraft = async () => {
        try {
            const userType = await UserService.getCurrentUserType();
            if (Number(userType) !== 2) {
                toast.info(t('MasavProfileSettingsAccountantOnly'));
                return;
            }
        } catch (_) {
            return;
        }
        setPendingAfterMasavProfileSave('refreshDraft');
        setMasavProfileModalOpen(true);
    };

    const [cardIdOption, setCardIdOption] = useState(-1);



    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const normalizeLedgerDraftPdfResults = (list) =>
        (Array.isArray(list) ? list : []).map((p) => {
            const paymentId = p.paymentId ?? p.PaymentId ?? null;
            const clientCaseId = p.clientCaseId ?? p.ClientCaseId ?? '';
            const clientName = p.clientName ?? p.ClientName ?? '';
            const reference = p.reference ?? p.Reference ?? '';
            const amountRaw = p.amount ?? p.Amount;
            const amount = amountRaw !== undefined && amountRaw !== null ? Number(amountRaw) : null;
            return {
                FileName: p.fileName ?? p.FileName ?? '',
                PdfBase64: p.pdfBase64 ?? p.PdfBase64 ?? '',
                fileName: p.fileName ?? p.FileName ?? '',
                pdfBase64: p.pdfBase64 ?? p.PdfBase64 ?? '',
                isGenerated: true,
                meta: {
                    clientName: clientName || null,
                    caseId: clientCaseId || null,
                    reference: reference || null,
                    amount: Number.isFinite(amount) ? amount : null,
                    paymentIds: paymentId ? [paymentId] : [],
                },
            };
        });

    const handleGenerateInvoicesDraft = async (invoiceSignature = null, invoiceReference = null, invoiceDateParam = null) => {
        if (!pickedPayments.length || isGenerating || isDraftingLedgerInvoices || isDraftingReceiptDrafts) return;

        const eligiblePayments = pickedPayments.filter(payment => !payment.invoiceId);

        if (!eligiblePayments.length) {
            toast.info(t('InvoicesAlreadyGenerated', { defaultValue: 'Selected payments already have invoices.' }));
            return;
        }

        if (eligiblePayments.length !== pickedPayments.length) {
            toast.info(
                t('ExcludedPaymentsWithInvoices', {
                    defaultValue: 'Payments with existing invoices were skipped from invoice generation.',
                })
            );
            setPickedPayments(eligiblePayments);
        }

        // When invoiceDateParam is null, user chose "Use payment date" → send null so server uses payment.Date
        const dateToUse = invoiceDateParam !== undefined ? invoiceDateParam : invoiceGenDate;

        setIsDraftingLedgerInvoices(true);
        try {
            // Use the leading business caseId if available, otherwise use current client
            const caseIdToUse = selectedClientCaseId || client.caseId;

            const resp = await EnumsService.GenerateLedgerInvoicesDraft(
                leadingBusinessCaseId,
                eligiblePayments,
                invoiceSignature,
                invoiceReference,
                dateToUse,
                token
            );

            if (!resp.ok) {
                toast.error((await resp.text()) || t('TaskFailed'));
                return;
            }

            const list = await resp.json();
            const normalized = normalizeLedgerDraftPdfResults(list);
            if (!normalized.length) {
                toast.info(t('NothingReturned'));
                return;
            }

            setLastPickedPayments(eligiblePayments);
            setPdfResults(normalized);
            setPdfIndex(0);
            setPreviewKind('invoice');
            setPreviewOpen(true);
            setPickedPayments([]);
            setPaymentActionMode(null);
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsDraftingLedgerInvoices(false);
        }
    };

    useEffect(() => {
        if (resumeInvoicesGeneration) {
            setResumeInvoicesGeneration(false);   // avoid loops
            handleGenerateInvoicesFinal(true);    // ← skips the auth check
        }
    }, [resumeInvoicesGeneration]);

    const handleGenerateInvoicesFinal = async (isAuthCompleted = false, decisionFlag = null) => {
        if (isGenerating || !lastPickedPayments.length) return;
        //Tax auth sh
        const needAuth = lastPickedPayments.some(p => {
            const limit = getIsraelInvoiceAmountLimit(new Date(p.date));
            return (p.amount || 0) >= limit;
        });

        const clientIsExempt = client?.caseType && Constants.TaxExemptTypes.includes(client.caseType);
        const mustAsk = true;            // always true for invoice PDFs that go to the Tax-Authority

        if (!clientIsExempt && needAuth && !isAuthCompleted) {
            try {
                const tokenData = await TaxAuthorityService.requestTokenClient(client.caseId, token, Constants.TaxAuthorityScopes.CreationNumber);
                if (tokenData?.authUrl) {
                    handleTaxAuthorityAuth(tokenData.authUrl);
                    return;                    // wait until the polling sets resumeInvoicesGeneration
                }
            } catch (err) {
                console.error(err);
                toast.error(t('TaxAuthorityAuthFetchError'));
                return;
            }
        }
        setIsGenerating(true);
        try {
            setLoading(true);

            const resp = await EnumsService.GenerateLedgerInvoices(
                client.caseId,
                lastPickedPayments,
                invoiceSignature,
                invoiceReference,
                invoiceGenDate,
                token,
                decisionFlag // Add the decision flag parameter
            );

            setInvoiceGenDate(null);

            const cTypeHeader = resp.headers.get('Content-Type') || '';

            /* ---------- structured JSON: all failed (400) or partial success (200) ---------- */
            if (cTypeHeader.includes('application/json')) {
                const data = await resp.json();
                await fetchEnums(user, token, client, null, null);

                if (!resp.ok) {
                    if (data?.failures?.length) {
                        const details = formatLedgerInvoiceFailureDetails(data.failures, t);
                        const headline = t('LedgerInvoicesAllFailed', { count: data.failures.length });
                        toast.error(details ? `${headline}\n\n${details}` : headline, {
                            autoClose: false,
                            style: { whiteSpace: 'pre-line' },
                        });
                    } else {
                        const rawError = typeof data === 'string' ? data : (data?.message || data?.error || JSON.stringify(data));
                        const { code } = parseServerError(rawError);
                        if (code) {
                            toast.error(t(`TaxInvoiceError${code}`), { autoClose: false });
                            if (
                                String(code) === String(Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED) ||
                                String(code) === String(Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT)
                            ) {
                                setIsTaxAuthorityErrorModalVisible(true);
                            }
                        } else {
                            toast.error(translateLedgerInvoiceError(rawError, t) || t('TaskFailed'), {
                                autoClose: false,
                                style: { whiteSpace: 'pre-line' },
                            });
                        }
                    }
                    return;
                }

                if (data?.partialSuccess && data?.failures?.length) {
                    const details = formatLedgerInvoiceFailureDetails(data.failures, t);
                    const headline = t('LedgerInvoicesPartialSuccess', {
                        ok: data.succeededCount ?? 0,
                        fail: data.failedCount ?? data.failures.length,
                    });
                    toast.warning(details ? `${headline}\n\n${details}` : headline, {
                        autoClose: 10000,
                        style: { whiteSpace: 'pre-line' },
                    });
                    return;
                }

                if (Array.isArray(data) && data.length === 0) {
                    toast.info(t('NothingReturned'));
                    return;
                }

                toast.success(t('InvoicesGenerated'));
                return;
            }

            if (!resp.ok) {
                const errorText = await resp.text();
                const { code, message } = parseServerError(errorText);
                
                // Always show a toast
                if (code) {
                    toast.error(t(`TaxInvoiceError${code}`), { autoClose: false });
                    
                    // Open TA decision modal on specific codes
                    if (
                        String(code) === String(Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED) ||
                        String(code) === String(Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT)
                    ) {
                        setIsTaxAuthorityErrorModalVisible(true);
                        return;
                    }
                } else {
                    toast.error(translateLedgerInvoiceError(errorText, t) || t('TaskFailed'));
                }
                return;
            }

            /* ---------- was the response a file? ---------- */
            const cType = resp.headers.get('Content-Type') || '';
            const isFile =
                cType.includes('application/pdf') || cType.includes('application/zip');

            if (isFile) {
                // 1) grab filename (if server sent it)
                const disp = resp.headers.get('Content-Disposition') || '';
                const match = disp.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                let filename =
                    match && match[1] ? match[1].replace(/['"]/g, '') : 'invoices';

                // 2) read the data
                const blob = await resp.blob();
                // add the proper extension if missing
                if (!/\.\w+$/.test(filename)) {
                    filename += cType.includes('pdf') ? '.pdf' : '.zip';
                }

                // 3) download
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                toast.success(t('InvoicesGenerated'));
            } else {
                // Handle possible plain-string success responses from backend (e.g., TA decisions)
                const textBody = await resp.text();
                try {
                    const resultJson = JSON.parse(textBody);
                    toast.success(t('InvoicesGenerated'));
                } catch (_) {
                    if (typeof textBody === 'string') {
                        if (textBody === 'Decision processed successfully') {
                            await Swal.fire({
                                title: t('Success') || 'Success!',
                                text: t('TaxAuthorityRequestSent'),
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                        } else {
                            toast.success(textBody);
                        }
                        setLoading(false);
                        return;
                    }
                    toast.success(t('InvoicesGenerated'));
                }
            }

            // refresh lists so the new documents appear
            fetchEnums(user, token, client, null, null);
        } catch (err) {
            console.error(err);

            const rawError = err?.message || '';
            const { code } = parseServerError(rawError);

            // Always show a toast
            if (code) {
                toast.error(t(`TaxInvoiceError${code}`), { autoClose: false });
                
                // Open TA decision modal on specific codes
                if (
                    String(code) === String(Constants.TaxAuthorityErrorCodes.INVOICE_NOT_APPROVED) ||
                    String(code) === String(Constants.TaxAuthorityErrorCodes.NO_DECISION_SENT)
                ) {
                    setIsTaxAuthorityErrorModalVisible(true);
                }
            } else {
                toast.error(translateLedgerInvoiceError(rawError, t) || t('TaskFailed'), {
                    autoClose: false,
                    style: { whiteSpace: 'pre-line' },
                });
            }
        } finally {
            setIsGenerating(false);
            setPreviewOpen(false);
            setPdfResults([]);
            setBlobUrl('');
            setLastPickedPayments([]);
            setLoading(false);
        }
    };


    const handleCloseSelectedPayments = async () => {
        if (!pickedPayments.length || isClosing) return;
        setIsClosing(true);
        try {
            // keep only the two fields the DTO needs
            const toSend = pickedPayments.map(p => ({ id: p.id, ledgerId: p.ledgerId }));

            const resp = await EnumsService.CloseSelectedPayments(
                user.accountantId,    // AccountantId
                toSend,
                token
            );

            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return;
            }

            toast.success(t('PaymentsClosed'));
            setPickedPayments([]);           // clear the check-boxes
            setPaymentActionMode(null);
            fetchEnums(user, token, client, null, null); // refresh lists
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsClosing(false);
        }
    };

    const handleOpenSelectedPayments = async () => {
        if (!pickedPayments.length || isClosing) return;
        setIsClosing(true);
        try {
            // keep only the two fields the DTO needs
            const toSend = pickedPayments.map(p => ({ id: p.id, ledgerId: p.ledgerId }));

            const resp = await EnumsService.OpenSelectedPayments(
                user.accountantId,    // AccountantId
                toSend,
                token
            );

            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return;
            }

            toast.success(t('PaymentsOpened'));
            setPickedPayments([]);           // clear the check-boxes
            setPaymentActionMode(null);
            fetchEnums(user, token, client, null, null); // refresh lists
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsClosing(false);
        }
    };

    const handleDeletePaymentRow = async (row, options = {}) => {
        const { fromModal = false } = options;
        if (!fromModal) {
            setPaymentMenuAnchor(null);
            setPaymentMenuRow(null);
        }
        const confirmed = await Swal.fire({
            title: t('ConfirmDelete'),
            text: t('DeletePaymentConfirmMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
        });
        if (!confirmed.isConfirmed) return false;
        try {
            const resp = await EnumsService.DeletePayment(row.id, token);
            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return false;
            }
            toast.success(t('ItemDeletedSuccessfully'));
            fetchEnums(user, token, client, null, null);
            if (fromModal) handleCloseDialog();
            return true;
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
            return false;
        }
    };

    const handleCancelPaymentManually = async (row, options = {}) => {
        const { fromModal = false } = options;
        if (!fromModal) {
            setPaymentMenuAnchor(null);
            setPaymentMenuRow(null);
        }
        const confirmed = await Swal.fire({
            title: t('CancelManually'),
            text: t('CancelPaymentManuallyConfirmMessage'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
        });
        if (!confirmed.isConfirmed) return false;
        try {
            const resp = await EnumsService.CancelPaymentManually(row.id, token);
            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return false;
            }
            toast.success(t('PaymentMarkedCanceledManually'));
            fetchEnums(user, token, client, null, null);
            if (fromModal) handleCloseDialog();
            return true;
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
            return false;
        }
    };

    const handleSetPaymentAmountNegative = async (row, options = {}) => {
        const { fromModal = false } = options;
        if (!fromModal) {
            setPaymentMenuAnchor(null);
            setPaymentMenuRow(null);
        }
        const confirmed = await Swal.fire({
            title: t('MakeAmountNegative'),
            text: t('MakeAmountNegativeConfirmMessage'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
        });
        if (!confirmed.isConfirmed) return false;
        try {
            const resp = await EnumsService.SetPaymentAmountNegative(row.id, token);
            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return false;
            }
            toast.success(t('PaymentExcludedFromCalculations'));
            fetchEnums(user, token, client, null, null);
            if (fromModal) handleCloseDialog();
            return true;
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
            return false;
        }
    };

    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        setSortConfig({ key, direction, type });
    };

    // table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }


    useEffect(() => {
        // Calculate the width as 70% of the container width minus 20px
        const containerWidth = document.querySelector('.table-container').offsetWidth;
        const newWidth = (containerWidth * 0.7) - 20;
        setCalculatedWidth(newWidth + 'px');
    }, []);

    const { hasBack, handleBack } = useBack();

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // handleBack();
            goBack()
        }
    };



    const sourceDeductionOptions = [
        { key: 'NotIncluded', label: t('NotIncluded') },
        { key: 'Included', label: t('Included') }
    ];


    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [deleteModalVisable, setDeleteModalVisable] = useState(null);

    const handleConfirmDelete = async () => {
        try {
            const response = await EnumsService.DeleteAccountCardsbyCaseId(client.caseId, itemIdToDelete.cardId, token);

            if (response.ok) {
                toast.success(t("Account card deleted successfully"));
                setDeleteModalVisable(false);
                fetchEnums(user, token, client, null, null); // Fetch updated enums after the delete action
            } else {
                const errorMessage = await response.text(); // Extract the error message from the response body
                if (errorMessage.includes("Account card can't be deleted, documents with account card exist")) {
                    toast.error(t('AccountCardCannotBeDeleted'));
                } else {
                    toast.error(t('TaskFailed'));
                }
            }

        } catch (error) {

            // Handle errors from the catch block (e.g., network issues or exceptions)
            if (error?.response?.data?.includes("Account card can't be deleted, documents with account card exist")) {
                toast.error(t('AccountCardCannotBeDeleted'));
            } else {
                toast.error(t('TaskFailed'));
            }
            console.error(t('TaskFailed'));
        }
    };
    const handleDeleteClick = (accountCard) => {
        setItemIdToDelete(accountCard);
        setDeleteModalVisable(true);
    };

    const clickedDisabled = (action) => {
        if (action === 'Edit') {
            toast.info(t('CannotEditThisAccountCard'));
        } else {
            toast.info(t('CannotDeleteAccountCard'));

        }
    };

    const clickedDisabledRow = () => {
        toast.info(t('LockedCardEditor'));
    };

    const [anySelected, setAnySelected] = useState(false);

    // const formatDate2 = (dateString) => {
    //     if (!dateString || !dayjs(new Date(dateString)).isValid()) return "-"; // Check for null/invalid dates
    //     return dayjs.utc(dateString).format('DD/MM/YYYY'); // UTC for consistent timezone
    // };

    const formatDate2 = (value) => {

        if (!value) {
            return "-"
        }
        return dayjs(value).format('MM/YYYY');
    };

    const formatDate3 = (value) => {

        if (!value) {
            return "-"
        }
        return dayjs(value).format('DD/MM/YYYY');
    };

    const PaymentTypeOptions = [
        { name: t("CreditCard"), value: "0" },
        { name: t("Check"), value: "1" },
        { name: t("BankTransfer"), value: "2" },
        { name: t("Cash"), value: "3" }
    ];

    const caseIdToName = {};
    minimalClientData.forEach(c => {
        caseIdToName[c.caseId] = c.name;
    });

    const masavPendingPaymentDays = useMasavPendingPaymentDays({
        accountantId: client?.accountantId,
        caseId: client?.caseId,
        isLeadingBusiness: !!client?.leadingBusiness,
        reloadKey: masavDraftReloadNonce,
    });
    const masavPendingByCase = useMemo(() => {
        const map = {};
        masavPendingPaymentDays.clients.forEach((c) => {
            map[c.caseId] = c;
        });
        return map;
    }, [masavPendingPaymentDays.clients]);

    // Add a "Client" column whenever this accountant is a leading business
    const addCaseIdCol = (cols) =>
        client?.leadingBusiness
            ? [
                {
                    field: 'clientInfo',
                    headerName: t('Client'),
                    flex: 1.3,
                    minWidth: 140,
                    headerAlign: 'center',
                    align: 'right',
                    sortable: false,
                    renderCell: (params) => {
                        const name = caseIdToName[params.row.caseId] || '';
                        const caseId = params.row.caseId;
                        return (
                            <div className={cs.clientCell}>
                                <UserAvatar name={name} size={28} withName={false} maxInitials={2} />
                                <div className={cs.clientText}>
                                    <span className={cs.clientName} title={name}>{name}</span>
                                    <span className={cs.clientCaseId}>{caseId}</span>
                                </div>
                                {masavPendingByCase[caseId] && (
                                    <Tooltip
                                        title={t('MasavPayDayBannerOne', {
                                            date: dayjs(masavPendingByCase[caseId].dueDate).format('DD/MM/YYYY'),
                                        })}
                                    >
                                        <EventBusyIcon sx={{ fontSize: 18, color: '#E57C22', flexShrink: 0 }} />
                                    </Tooltip>
                                )}
                            </div>
                        );
                    },
                },
                ...cols,
            ]
            : cols;

    // Define columns for each DataGrid
    const monthlyChargesColumns = addCaseIdCol([
        {
            field: 'startDate',
            headerName: t('StartDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortComparator: (v1, v2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            },
            valueFormatter: (value) => formatDate2(value)
        },
        {
            field: 'endDate',
            headerName: t('EndDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortComparator: (v1, v2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            },
            valueFormatter: (value) => formatDate2(value)
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                const value = Number(params);
                return isNaN(value) ? '' : beautifyNumber(value);
            }
        },
        ...(!client?.leadingBusiness
            ? [
                {
                    field: 'description',
                    headerName: t('Description'),
                    flex: 1,
                    headerAlign: 'center',
                    align: 'center',
                },
            ]
            : []),
        {
            field: 'createdBy',
            headerName: t('DocumentCreatedBy'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            valueGetter: (value, row) => {
                const uid = row?.createdByUserId;
                const utype = row?.createdByUserType;
                if (!uid && !utype) return '';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
            renderCell: (params) => {
                const uid = params.row.createdByUserId;
                const utype = params.row.createdByUserType;
                if (!uid && !utype) return '—';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
        },
        {
            field: 'edit',
            headerName: '',
            renderCell: (params) => (
                <IconButton onClick={() => handleOpenDialog('monthlyCharges', params.row)}>
                    <img src={editIcon} alt="Edit" />
                </IconButton>
            ),
            sortable: false,
            width: 50,
            align: 'center'
        },
    ]);

    const oneTimeChargesColumns = addCaseIdCol([
        {
            field: 'date',
            headerName: t('date'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortComparator: (v1, v2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            },
            valueFormatter: (value) => formatDate3(value)
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                const value = Number(params);
                return isNaN(value) ? '' : beautifyNumber(value);
            }
        },
        ...(!client?.leadingBusiness
            ? [
                {
                    field: 'description',
                    headerName: t('Description'),
                    flex: 1,
                    headerAlign: 'center',
                    align: 'center',
                },
            ]
            : []),
        {
            field: 'createdBy',
            headerName: t('DocumentCreatedBy'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            valueGetter: (value, row) => {
                const uid = row?.createdByUserId;
                const utype = row?.createdByUserType;
                if (!uid && !utype) return '';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
            renderCell: (params) => {
                const uid = params.row.createdByUserId;
                const utype = params.row.createdByUserType;
                if (!uid && !utype) return '—';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
        },
        {
            field: 'edit',
            headerName: '',
            renderCell: (params) => (
                <IconButton onClick={() => handleOpenDialog('oneTimeCharges', params.row)}>
                    <img src={editIcon} alt="Edit" />
                </IconButton>
            ),
            sortable: false,
            width: 50,
            align: 'center'
        },
    ]);

    const paymentsColumns = addCaseIdCol([
        {
            field: 'type',
            headerName: t('Type'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                // Log the entire params object
                const value = params; // Destructure value safely
                if (value === undefined) {
                    console.warn('Warning: "type" value is undefined');
                    return 'Unknown'; // Fallback for undefined values
                }
                const option = PaymentTypeOptions.find(opt => opt.value == value);
                return option ? option.name : value; // Return name or raw value
            }
        },
        {
            field: 'date',
            headerName: t('date'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortComparator: (v1, v2) => {
                const date1 = new Date(v1);
                const date2 = new Date(v2);
                return date1 - date2;
            },
            valueFormatter: (value) => formatDate3(value)
        },
        {
            field: 'invoiceId',
            headerName: t('InvoiceCreated'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {

                const value = params;

                return value ? t('Yes') : t('No');
            }
        },
        {
            field: 'receiptId',
            headerName: t('ReceiptCreated'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {

                const value = params;

                return value ? t('Yes') : t('No');
            }
        },
        {
            field: 'amount',
            headerName: t('Amount'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {

                const value = Number(params);
                return isNaN(value) ? '' : beautifyNumber(value);
            }
        },
        {
            field: 'isClosed',
            headerName: t('Status'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                const value = params;
                return value ? t('Closed') : t('Open');
            },
            renderCell: (params) => {
                const isClosed = params.value;
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%'
                        }}
                    >
                        <Chip
                            label={isClosed ? t('Closed') : t('Open')}
                            size="small"
                            color={isClosed ? 'error' : 'success'}
                            variant="outlined"
                            sx={{
                                fontSize: '0.75rem',
                                height: '24px'
                            }}
                        />
                    </Box>
                );
            }
        },
        {
            field: 'canceledStatus',
            headerName: t('CanceledStatus'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                const row = params?.row ?? {};
                const parts = [];
                if (row.invoiceIsCanceled) parts.push(t('CanceledInvoice'));
                if (row.receiptIsCanceled) parts.push(t('CanceledReceipt'));
                if (row.isCanceledManually) parts.push(t('CanceledManually'));
                return parts.length ? parts.join(' / ') : '—';
            },
            renderCell: (params) => {
                const parts = [];
                if (params.row.invoiceIsCanceled) parts.push(t('CanceledInvoice'));
                if (params.row.receiptIsCanceled) parts.push(t('CanceledReceipt'));
                if (params.row.isCanceledManually) parts.push(t('CanceledManually'));
                if (parts.length === 0) return '—';
                const amountPositive = Number(params.row.amount) > 0;
                return (
                    <Box>
                        <Typography variant="body2" color="error" sx={{ fontSize: '0.75rem' }}>
                            {parts.join(' / ')}
                        </Typography>
                        {amountPositive && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25, fontStyle: 'italic' }}>
                                {t('CanceledMakeAmountNegativeMessage')}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'createdBy',
            headerName: t('DocumentCreatedBy'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            valueGetter: (value, row) => {
                const uid = row?.createdByUserId;
                const utype = row?.createdByUserType;
                if (!uid && !utype) return '';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
            renderCell: (params) => {
                const uid = params.row.createdByUserId;
                const utype = params.row.createdByUserType;
                if (!uid && !utype) return '—';
                const found = subAccountantOptions?.find(option => option.value === uid);
                if (found?.label) return found.label;
                if (utype === 'Client') return t('Client');
                return uid && utype ? `${uid} (${utype})` : (uid || utype);
            },
        },
        ...(!client?.leadingBusiness
            ? [
                {
                    field: 'description',
                    headerName: t('Description'),
                    flex: 1,
                    headerAlign: 'center',
                    align: 'center',
                },
                {
                    field: 'reference',
                    headerName: t('Reference'),
                    flex: 1,
                    headerAlign: 'center',
                    align: 'center',
                },
            ]
            : []),
        {
            field: 'selectOrEdit',
            headerName: '',
            sortable: false,
            width: 50,
            align: 'center',
            disableColumnMenu: true,   // ← only this column loses the menu


            /* HEADER – "select all" for invoice/receipt/close modes (multi-select) */
            renderHeader: () =>
                (paymentActionMode === 'invoice' || paymentActionMode === 'receipt' || paymentActionMode === 'close' || paymentActionMode === 'reopen') ? (
                    <Checkbox
                        size="small"
                        checked={allChecked}
                        indeterminate={someChecked}
                        onChange={(e) => handleToggleAll(e.target.checked)}
                    />
                ) : null,

            /* CELL – checkbox when in action mode; only for eligible rows per mode */
            renderCell: (params) => {
                if (paymentActionMode === 'invoice') {
                    if (params.row.invoiceId) return null;
                    const isChecked = pickedPayments.some(p => p.id === params.row.id);
                    return (
                        <Checkbox
                            size="small"
                            checked={isChecked}
                            onChange={(e) => {
                                setPickedPayments(prev =>
                                    e.target.checked
                                        ? [...prev, params.row]
                                        : prev.filter(p => p.id !== params.row.id)
                                );
                            }}
                        />
                    );
                }
                if (paymentActionMode === 'receipt') {
                    if (params.row.receiptId) return null;
                    const isChecked = pickedPayments.some(p => p.id === params.row.id);
                    return (
                        <Checkbox
                            size="small"
                            checked={isChecked}
                            onChange={(e) => {
                                setPickedPayments(prev =>
                                    e.target.checked
                                        ? [...prev, params.row]
                                        : prev.filter(p => p.id !== params.row.id)
                                );
                            }}
                        />
                    );
                }
                if (paymentActionMode === 'close') {
                    if (params.row.isClosed) return null;
                    const isChecked = pickedPayments.some(p => p.id === params.row.id);
                    return (
                        <Checkbox
                            size="small"
                            checked={isChecked}
                            onChange={(e) => {
                                setPickedPayments(prev =>
                                    e.target.checked
                                        ? [...prev, params.row]
                                        : prev.filter(p => p.id !== params.row.id)
                                );
                            }}
                        />
                    );
                }
                if (paymentActionMode === 'reopen') {
                    if (!params.row.isClosed) return null;
                    const isChecked = pickedPayments.some(p => p.id === params.row.id);
                    return (
                        <Checkbox
                            size="small"
                            checked={isChecked}
                            onChange={(e) => {
                                setPickedPayments(prev =>
                                    e.target.checked
                                        ? [...prev, params.row]
                                        : prev.filter(p => p.id !== params.row.id)
                                );
                            }}
                        />
                    );
                }

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                        <IconButton size="small" onClick={() => handleOpenDialog('payments', params.row)} title={t('Edit')}>
                            <img src={editIcon} alt="Edit" style={{ width: 18, height: 18 }} />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); setPaymentMenuAnchor(e.currentTarget); setPaymentMenuRow(params.row); }}
                            title={t('Actions')}
                        >
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    </Box>
                );
            }

        },
    ]);

    const paymentActionMenuOpen = Boolean(paymentMenuAnchor);


    const [dialogOpen, setDialogOpen] = useState(false);
    const [itemType, setItemType] = useState('');
    const [newItem, setNewItem] = useState({}); // State to hold new item data
    const [isEditMode, setIsEditMode] = useState(false);

    const handleOpenDialog = (type, item = null) => {

        setItemType(type);
        setIsEditMode(Boolean(item));
        if (type === 'monthlyCharges') {
            setNewItem(item || {
                startDate: new Date(),
                endDate: null,
                amount: 0,
                description: '',
            });
        } else if (type === 'oneTimeCharges') {
            setNewItem(item || {
                date: new Date(),
                amount: 0,
                description: '',
            });
        } else if (type === 'payments') {
            setNewItem(item || {
                type: 1,
                date: new Date(),
                amount: 0,
                description: '',
                reference: '',
                // For non-leading business clients, include the current client's caseId
                caseId: client?.leadingBusiness ? undefined : client?.caseId,
            });
        }

        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setNewItem({});
    };

    const handleEditItem = async (newItem) => {
        try {
            let response;

            const collectionPageId =
                newItem.id
                    ? newItem.ledgerId
                    : collectionPageData.id;
            switch (itemType) {
                case 'monthlyCharges':
                    // Adjust dates to first day of the month in UTC
                    let adjustedStartDateEdit = newItem.startDate;
                    if (adjustedStartDateEdit) {
                        const startDateObj = new Date(adjustedStartDateEdit);
                        adjustedStartDateEdit = new Date(Date.UTC(startDateObj.getUTCFullYear(), startDateObj.getUTCMonth(), 1));
                    }
                    
                    let adjustedEndDateEdit = newItem.endDate;
                    if (adjustedEndDateEdit) {
                        const endDateObj = new Date(adjustedEndDateEdit);
                        adjustedEndDateEdit = new Date(Date.UTC(endDateObj.getUTCFullYear(), endDateObj.getUTCMonth(), 1));
                    }
                    
                    response = await EnumsService.EditMonthlyCharge(
                        newItem.id, // Use existing ID to edit
                        collectionPageId,
                        adjustedStartDateEdit,
                        adjustedEndDateEdit,
                        newItem.amount,
                        newItem.description,
                        token
                    );
                    break;
                case 'oneTimeCharges':
                    response = await EnumsService.EditOneTimeCharge(
                        newItem.id,
                        collectionPageId,
                        newItem.date,
                        newItem.amount,
                        newItem.description,
                        token
                    );
                    break;
                case 'payments':
                    response = await EnumsService.EditPayment(
                        newItem.id,
                        collectionPageId,
                        newItem.type,
                        newItem.date,
                        newItem.amount,
                        newItem.description,
                        newItem.reference,
                        newItem.bankName ?? null,          // ⑦ bankName
                        newItem.bankCode ?? null,          // ⑧ bankCode
                        newItem.bankBranchCode ?? null,    // ⑨ branchCode
                        newItem.supplierAccountNumber ?? null,
                        token
                    );
                    break;
                default:
                    console.error(`Unknown item type: ${itemType}`);
                    return;
            }

            if (response.ok) {

                await fetchEnums(user, token, client, null, null); // Refresh data after editing
            } else {
                const errorText = await response.text();
                console.error(`Failed to edit item in ${itemType}:`, errorText);
            }
        } catch (error) {
            console.error(`Error editing item in ${itemType}:`, error);
        } finally {
            handleCloseDialog();
        }
    };

    const handleInputChange = (field, value) => {

        setNewItem((prev) => ({ ...prev, [field]: value }));
    };

    const [newPaymentDetails, setNewPaymentDetails] = useState({});
    const [isFinalReciept, setIsFinalReciept] = useState(false);
    const [isMultiplePayments, setIsMultiplePayments] = useState(false);
    const [multiplePaymentIds, setMultiplePaymentIds] = useState([]);
    const [selectedClientCaseId, setSelectedClientCaseId] = useState(null);
    const [leadingBusinessCaseId, setLeadingBusinessCaseId] = useState(null);

    const generateReceiptDraftMultiple = async (paymentIds, selectedClientCaseId = null, receiptDate = null) => {
        try {
            setLoading(true);
            setIsDraftingReceiptDrafts(true);

            // Use the leading business caseId if available, otherwise fall back to selected or current client
            const clientToPayCaseId =  selectedClientCaseId || client.caseId;

            const resp = await EnumsService.GenerateReceiptFromMultiplePaymentsDraft(
                leadingBusinessCaseId,  // Main business/accountant caseId (leading business)
                clientToPayCaseId,      // Client caseId where payments were created
                paymentIds,
                invoiceSignature,
                invoiceReference,
                token,
                receiptDate
            );

            if (!resp.ok) {
                const errorText = await resp.text();
                console.error('Receipt generation failed:', errorText);
                toast.error(t('TaskFailed') + ': ' + errorText);
                setLoading(false);
                setIsDraftingReceiptDrafts(false);
                return;
            }

            setIsFinalReciept(false);
            setIsMultiplePayments(true);
            setMultiplePaymentIds(paymentIds);
            setSelectedClientCaseId(selectedClientCaseId);
            const blob = await resp.blob();        // <- PDF bytes
            openDraftPdfModal(blob);               // show inside the app
            toast.success(t('DraftDocumentCreated'));

            /* ---- automatic download ---- */
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            // you can change the filename format to whatever you need
            link.download = `receipt-multiple-${paymentIds.join('-')}.pdf`;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            fetchEnums(null, token, client, null, null);
            setLoading(false);
            setIsDraftingReceiptDrafts(false);
        } catch (err) {
            setLoading(false);
            setIsDraftingReceiptDrafts(false);
            console.error(err);
            toast.error(t('TaskFailed'));
        }
    };

    const generateReceiptFinalMultiple = async (paymentIds, selectedClientCaseId = null, referenceOverride = null) => {
        // Block a second concurrent generate (double-click) which previously created duplicate receipts.
        if (isGeneratingReceipts) {
            console.warn('[Receipt] generation already in progress; ignoring duplicate trigger');
            return;
        }
        try {
            setIsGeneratingReceipts(true);
            setLoading(true);

            // Use the leading business caseId if available, otherwise fall back to selected or current client
            const caseIdToUse =  selectedClientCaseId || client.caseId;

            const resp = await EnumsService.GenerateReceiptFromMultiplePayments(
                leadingBusinessCaseId,        // Main business/accountant caseId (leading business)
                caseIdToUse,        // Client caseId where payments were created
                paymentIds,
                invoiceSignature,
                referenceOverride ?? invoiceReference,
                token
            );

            if (!resp.ok) {
                // 409 = server idempotency guard: a receipt already exists for these payment(s).
                if (resp.status === 409) {
                    toast.info(t('ReceiptAlreadyGenerated'));
                } else {
                    toast.error(t('TaskFailed'));
                }
                setLoading(false);
                return;
            }

            setIsFinalReciept(true);
            const blob = await resp.blob();        // <- PDF bytes
            openDraftPdfModal(blob);               // show inside the app
            toast.success(t('DraftDocumentCreated'));

            /* ---- automatic download ---- */
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            // you can change the filename format to whatever you need
            link.download = `receipt-multiple-final-${paymentIds.join('-')}.pdf`;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            fetchEnums(null, token, client, null, null);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsGeneratingReceipts(false);
        }
    };

    const base64ToPdfBlob = (b64) => {
        try {
            const bin = atob(b64);
            const uint = Uint8Array.from(bin, (c) => c.charCodeAt(0));
            return new Blob([uint], { type: 'application/pdf' });
        } catch (e) {
            console.error('Failed to decode PDF base64', e);
            return null;
        }
    };

    /** Single API call: generate all per-client receipt drafts, then open each draft in openDraftPdfModal flow. */
    const dispatchReceiptDraftBulkPreview = async (jobs) => {
        if (!jobs?.length) return;
        // Block a second concurrent draft generation (double-click / rapid re-trigger).
        if (isDraftingReceiptDrafts || isGeneratingReceipts) {
            console.warn('[Bulk receipt drafts] generation already in progress; ignoring duplicate trigger');
            return;
        }
        setLoading(true);
        setIsDraftingReceiptDrafts(true);
        try {
            const requests = jobs.map((job) => ({
                clientToPayCaseId: job.caseId,
                paymentIds: job.paymentIds,
                receiptDate: job.receiptDate || null,
            }));
            const resp = await EnumsService.GenerateReceiptFromMultiplePaymentsDraftBulk(
                leadingBusinessCaseId,
                requests,
                invoiceSignature,
                invoiceReference,
                token,
                null
            );
            if (!resp.ok) {
                const err = await resp.text();
                toast.error(t('TaskFailed') + (err ? `: ${err}` : ''));
                return;
            }

            const payload = await resp.json();
            const results = Array.isArray(payload?.pdfResults) ? payload.pdfResults : [];
            const failures = Array.isArray(payload?.failures) ? payload.failures : [];
            const normalized = results.map((r) => ({
                fileName: r.fileName || r.FileName || `receipt-${r.clientToPayCaseId || 'client'}.pdf`,
                FileName: r.fileName || r.FileName || `receipt-${r.clientToPayCaseId || 'client'}.pdf`,
                pdfBase64: r.pdfBase64 || r.PdfBase64 || '',
                PdfBase64: r.pdfBase64 || r.PdfBase64 || '',
                caseId: r.clientToPayCaseId || r.ClientToPayCaseId || '',
                paymentIds: r.paymentIds || r.PaymentIds || [],
                reference: r.reference || r.Reference || null,
            }));

            if (failures.length && normalized.length) {
                toast.warning(
                    t('MasavBulkReceiptPartialDraftSuccess', {
                        ok: normalized.length,
                        failed: failures.length,
                    })
                );
            } else if (failures.length) {
                toast.error(t('MasavBulkReceiptAllDraftsFailed'));
            }

            if (!normalized.length) return;

            // Step 1 for receipts: show drafts in the same preview modal used for invoice drafts
            // Enrich with UI meta (client name/amount) so we can show summaries.
            const metaByKey = new Map(
                (Array.isArray(jobs) ? jobs : []).map((j) => [
                    `${String(j.caseId ?? '').trim()}:${(j.paymentIds || []).join(',')}`,
                    { clientName: j.clientName, amount: j.amount, receiptDate: j.receiptDate }
                ])
            );
            const enriched = normalized.map((r) => {
                const key = `${String(r.caseId ?? '').trim()}:${(r.paymentIds || []).join(',')}`;
                return {
                    ...r,
                    isGenerated: true,
                    meta: {
                        caseId: r.caseId,
                        paymentIds: r.paymentIds,
                        reference: r.reference,
                        clientName: metaByKey.get(key)?.clientName || null,
                        amount: metaByKey.get(key)?.amount ?? null,
                        receiptDate: metaByKey.get(key)?.receiptDate || null,
                    }
                };
            });

            setReceiptBulkJobs(jobs);
            setPreviewKind('receipt');
            setPdfResults(enriched);
            setPreviewOpen(true);

            if (!failures.length) toast.success(t('DraftDocumentCreated'));
        } catch (e) {
            console.error(e);
            toast.error(t('TaskFailed'));
        } finally {
            setLoading(false);
            setIsDraftingReceiptDrafts(false);
            fetchEnums(null, token, client, null, null);
        }
    };

    /** Single API call: generate all per-client FINAL receipts, then open each PDF in the same modal queue flow. */
    const dispatchReceiptFinalBulkPreview = async (jobs) => {
        if (!jobs?.length) return;
        // Block a second concurrent generate (double-click / rapid re-trigger) which caused duplicates.
        if (isGeneratingReceipts) {
            console.warn('[Bulk receipts] generation already in progress; ignoring duplicate trigger');
            return;
        }
        setIsGeneratingReceipts(true);
        setLoading(true);
        try {
            const requests = jobs.map((job) => ({
                clientToPayCaseId: job.caseId,
                paymentIds: job.paymentIds,
                receiptDate: job.receiptDate || null,
            }));

            const resp = await EnumsService.GenerateReceiptFromMultiplePaymentsBulk(
                leadingBusinessCaseId,
                requests,
                invoiceSignature,
                invoiceReference,
                token,
                null
            );
            if (!resp.ok) {
                const err = await resp.text();
                toast.error(t('TaskFailed') + (err ? `: ${err}` : ''));
                return;
            }

            const payload = await resp.json();
            const results = Array.isArray(payload?.pdfResults) ? payload.pdfResults : [];
            const failures = Array.isArray(payload?.failures) ? payload.failures : [];
            const skips = Array.isArray(payload?.skipped) ? payload.skipped : [];

            // Map caseId -> friendly client name from the jobs we submitted.
            const nameByCaseId = new Map(
                (Array.isArray(jobs) ? jobs : []).map((j) => [
                    String(j.caseId ?? '').trim(),
                    j.clientName || null,
                ])
            );
            const labelFor = (caseId) => {
                const id = String(caseId ?? '').trim();
                const name = nameByCaseId.get(id);
                return name ? `${name} (${id})` : id || '—';
            };

            const succeeded = results.map((r) => {
                const caseId = r.clientToPayCaseId || r.ClientToPayCaseId || '';
                return {
                    caseId,
                    label: labelFor(caseId),
                    reference: r.reference || r.Reference || null,
                };
            });
            const failed = failures.map((f) => {
                const caseId = f.clientToPayCaseId || f.ClientToPayCaseId || '';
                return {
                    caseId,
                    label: labelFor(caseId),
                    error: f.error || f.Error || t('TaskFailed'),
                };
            });
            const skipped = skips.map((s) => {
                const caseId = s.clientToPayCaseId || s.ClientToPayCaseId || '';
                return {
                    caseId,
                    label: labelFor(caseId),
                    reason: s.reason || s.Reason || 'AlreadyGenerated',
                };
            });

            // Detailed logs so the operator can see exactly who succeeded, failed, or was skipped.
            console.groupCollapsed(
                `[Bulk receipts] succeeded: ${succeeded.length}, failed: ${failed.length}, skipped: ${skipped.length}`
            );
            if (succeeded.length) console.table(succeeded);
            if (failed.length) console.table(failed);
            if (skipped.length) console.table(skipped);
            console.groupEnd();

            const renderList = (items, withError) => (
                <ul style={{ margin: '4px 0 0', paddingInlineStart: 18 }}>
                    {items.map((it, idx) => (
                        <li key={idx}>
                            {it.label}
                            {withError && it.error ? ` — ${it.error}` : ''}
                        </li>
                    ))}
                </ul>
            );

            // Base the toast strictly on what the server actually generated,
            // so a full success never shows a failure toast.
            if (failed.length && succeeded.length) {
                toast.warning(
                    <div>
                        <div>
                            {t('MasavBulkReceiptPartialFinalizeSuccess', {
                                ok: succeeded.length,
                                failed: failed.length,
                            })}
                        </div>
                        <div style={{ marginTop: 6, fontWeight: 600 }}>
                            {t('BulkReceiptsSucceededHeader')}
                        </div>
                        {renderList(succeeded, false)}
                        <div style={{ marginTop: 6, fontWeight: 600 }}>
                            {t('BulkReceiptsFailedHeader')}
                        </div>
                        {renderList(failed, true)}
                    </div>,
                    { autoClose: false }
                );
            } else if (failed.length) {
                toast.error(
                    <div>
                        <div>{t('MasavBulkReceiptAllFinalizeFailed')}</div>
                        {renderList(failed, true)}
                    </div>,
                    { autoClose: false }
                );
            } else {
                // Final receipts: backend already updated payments with ReceiptId.
                // We avoid opening another modal here to keep this a strict 2-step flow.
                toast.success(t('MasavBulkReceiptAllFinalizeSuccess', { ok: succeeded.length }));
            }
        } catch (e) {
            console.error('[Bulk receipts] request failed', e);
            toast.error(t('TaskFailed') + (e?.message ? `: ${e.message}` : ''));
        } finally {
            setIsGeneratingReceipts(false);
            setLoading(false);
            fetchEnums(null, token, client, null, null);
        }
    };

    /** Record created payments on the MASAV batch rows; failures only warn (payments already exist). */
    const recordMasavBatchApplied = async (items) => {
        const batchId = masavBatchContext?.batchId;
        if (!batchId || !client?.accountantId || !items.length) return;
        try {
            await masavService.markMasavBatchItemsApplied(client.accountantId, batchId, items);
        } catch (e) {
            console.error(e);
            toast.warning(t('MasavBatchTrackingFailed'));
        }
    };

    const handleMasavBulkReceiptSubmit = async ({
        paymentMethod = MasavPaymentMethods.bank,
        shared,
        rows,
        selectedClientCount = 0,
        totalClientCount = 0,
        generateReceiptDraft,
        receiptDate,
        useItemDescriptions = false,
    }) => {
        if (!rows?.length || !shared?.type || !shared?.date) return;
        const vatRate = getVatValue(shared.date);
        const includes = shared.priceIncludingVAT ?? true;
        const buildAmount = (rawStr) => {
            const raw = parseFloat(rawStr) || 0;
            const net = raw;
            const gross = raw * (1 + vatRate);
            return includes ? net : gross;
        };
        // Per-item mode: each payment gets the client's own charge description(s);
        // the shared description is only a fallback for clients without one.
        const descriptionFor = (row) => {
            const own = String(row?.itemDescription ?? '').trim();
            return useItemDescriptions && own ? own : shared.description;
        };

        const seenCaseIds = new Set();
        const uniqueRows = [];
        for (const row of rows) {
            const cid = String(row.caseId ?? '').trim();
            if (!cid || seenCaseIds.has(cid)) continue;
            seenCaseIds.add(cid);
            uniqueRows.push(row);
        }

        const eligibleRows = uniqueRows.filter((r) => Number(parseFloat(String(r.amount ?? '0'))) > 0);
        if (!eligibleRows.length) {
            toast.error(t('MasavBulkReceiptErrAmount'));
            return;
        }

        // ───────── Credit-card mode: charge each row via the saved card. ─────────
        // The server's LedgerBridge creates the CreditCard payment in the
        // client's ledger automatically when the charge succeeds, so we only
        // need to call the charge endpoint here and refresh the ledger.
        if (paymentMethod === MasavPaymentMethods.creditCard) {
            setMasavBulkReceiptSubmitting(true);
            setMasavCcChargeProgress({});
            let okCount = 0;
            const failures = [];
            const chargedCaseIds = [];
            try {
                for (const row of eligibleRows) {
                    if (!row.savedCardId) {
                        failures.push({ caseId: row.caseId, clientName: row.clientName, message: t('SavedCards.noCard') });
                        setMasavCcChargeProgress((prev) => ({ ...prev, [row.caseId]: 'failed' }));
                        continue;
                    }
                    setMasavCcChargeProgress((prev) => ({ ...prev, [row.caseId]: 'pending' }));
                    try {
                        const resp = await clientSavedCardsService.charge({
                            clientCaseId: row.caseId,
                            savedCardId: row.savedCardId,
                            amount: buildAmount(row.amount),
                            description: descriptionFor(row),
                            reference: shared.reference || null,
                            paymentDate: shared.date,
                        });
                        // Backend Status: 1 = Charged. Anything else = failed.
                        if (resp && (resp.status === 1 || resp.Status === 1)) {
                            okCount += 1;
                            chargedCaseIds.push(row.caseId);
                            setMasavCcChargeProgress((prev) => ({ ...prev, [row.caseId]: 'success' }));
                        } else {
                            const msg = resp?.errorMessage || resp?.ErrorMessage || t('MasavBulkReceiptChargeFailedRow');
                            failures.push({ caseId: row.caseId, clientName: row.clientName, message: msg });
                            setMasavCcChargeProgress((prev) => ({ ...prev, [row.caseId]: 'failed' }));
                        }
                    } catch (e) {
                        failures.push({ caseId: row.caseId, clientName: row.clientName, message: e?.message || String(e) });
                        setMasavCcChargeProgress((prev) => ({ ...prev, [row.caseId]: 'failed' }));
                    }
                }

                await recordMasavBatchApplied(
                    chargedCaseIds.map((caseId) => ({ caseId, paymentIds: [], receiptGenerated: false }))
                );
                await fetchEnums(null, token, client, null, null);
                setMasavDraftReloadNonce((n) => n + 1);

                if (okCount && !failures.length) toast.success(t('MasavBulkReceiptChargeSuccess', { count: okCount }));
                else if (okCount && failures.length) {
                    toast.warning(
                        `${t('MasavBulkReceiptChargePartial', { saved: okCount, failed: failures.length })} — ${failures[0].message}`,
                        { autoClose: 10000 },
                    );
                } else if (!okCount && failures.length) {
                    toast.error(
                        failures.map((f) => `${f.clientName}: ${f.message}`).join('\n')
                            || t('MasavBulkReceiptChargeAllFailed'),
                        { autoClose: 12000 },
                    );
                }

                if (!failures.length) {
                    setMasavBulkReceiptOpen(false);
                    setMasavBulkReceiptRows([]);
                    setMasavCcChargeProgress({});
                    setMasavBatchContext(null);
                }
            } catch (err) {
                console.error(err);
                toast.error(t('TaskFailed'));
            } finally {
                setMasavBulkReceiptSubmitting(false);
            }
            return;
        }

        setMasavBulkReceiptSubmitting(true);
        const jobs = [];
        const paymentFailures = [];

        try {
            for (const row of eligibleRows) {
                const paymentDto = {
                    type: parseInt(shared.type, 10),
                    date: shared.date,
                    amount: buildAmount(row.amount),
                    description: descriptionFor(row),
                    reference: shared.reference || '',
                    bankName: shared.bankName || null,
                    bankCode: shared.bankCode || null,
                    bankBranchCode: shared.bankBranchCode || null,
                    supplierAccountNumber: shared.supplierAccountNumber || null,
                };
                try {
                    const response = await EnumsService.AddMultiplePayments(
                        { caseId: row.caseId, payments: [paymentDto] },
                        token
                    );
                    if (!response.ok) {
                        const errorText = await response.text();
                        paymentFailures.push({
                            caseId: row.caseId,
                            clientName: row.clientName,
                            message: errorText,
                        });
                        continue;
                    }
                    const created = await response.json();
                    const paymentIds = (Array.isArray(created) ? created : []).map((p) => p.id ?? p.Id).filter(Boolean);
                    if (paymentIds.length) {
                        jobs.push({
                            paymentIds,
                            caseId: row.caseId,
                            clientName: row.clientName,
                            receiptDate: receiptDate || new Date().toISOString().slice(0, 10),
                        });
                    }
                } catch (e) {
                    console.error(e);
                    paymentFailures.push({
                        caseId: row.caseId,
                        clientName: row.clientName,
                        message: e?.message || String(e),
                    });
                }
            }

            await recordMasavBatchApplied(
                jobs.map((j) => ({
                    caseId: j.caseId,
                    paymentIds: j.paymentIds.map(String),
                    receiptGenerated: !!generateReceiptDraft,
                }))
            );
            await fetchEnums(null, token, client, null, null);
            setMasavDraftReloadNonce((n) => n + 1);

            const successfulCaseIds = new Set(jobs.map((j) => String(j.caseId ?? '')));
            const keepOpenForNextClient = selectedClientCount === 1 && totalClientCount > 1;

            if (keepOpenForNextClient) {
                setMasavBulkReceiptRows((prev) => {
                    const remaining = prev.filter((r) => !successfulCaseIds.has(String(r.caseId ?? '')));
                    if (!remaining.length) {
                        setMasavBulkReceiptOpen(false);
                        setMasavBatchContext(null);
                        return [];
                    }
                    return remaining;
                });
            } else {
                setMasavBulkReceiptOpen(false);
                setMasavBulkReceiptRows([]);
                setMasavBatchContext(null);
            }

            if (jobs.length && !paymentFailures.length) {
                toast.success(t('MasavBulkReceiptPaymentsRecorded'));
            } else if (jobs.length && paymentFailures.length) {
                toast.warning(
                    t('MasavBulkReceiptPartialPaymentSuccess', {
                        saved: jobs.length,
                        failed: paymentFailures.length,
                    })
                );
            } else if (!jobs.length && paymentFailures.length) {
                toast.error(t('MasavBulkReceiptAllPaymentsFailed'));
            }

            if (generateReceiptDraft && jobs.length) {
                const { needSig, needRef } = await signatureChecklist('receipt');
                if (needSig || needRef) {
                    await runWithSigRefCheck({ act: 'receiptDraftMultipleBulk', jobs });
                } else {
                    await dispatchReceiptDraftBulkPreview(jobs);
                }
            }
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setMasavBulkReceiptSubmitting(false);
        }
    };

    const handleGenerateSingleReceiptDraft = async () => {
        if (!pickedPayments.length || pickedPayments.length !== 1 || isGenerating) return;

        setIsGenerating(true);
        try {
            const payment = pickedPayments[0];
            
            // Show date selection dialog
            const result = await Swal.fire({
                title: '?' + t('GenerateReceipt'),
                html: `
                    <p>${t('WouldYouLikeToGenerateAReceiptNow')}</p>
                    <div style="margin-top: 15px;">
                        <label for="receipt-date-single" style="display: block; margin-bottom: 5px; font-weight: bold;">${t('ReceiptDate')}:</label>
                        <input type="date" id="receipt-date-single" class="swal2-input" value="${new Date().toISOString().split('T')[0]}">
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('Yes'),
                cancelButtonText: t('No'),
                preConfirm: () => {
                    const dateInput = document.getElementById('receipt-date-single');
                    const selectedDate = dateInput.value;
                    if (!selectedDate) {
                        Swal.showValidationMessage(t('PleaseSelectADate'));
                        return false;
                    }
                    return selectedDate;
                }
            });

            if (result.isConfirmed) {
                const selectedDate = result.value;
                
                // Use multiple payments endpoint for consistency (even with single payment)
                if (client.leadingBusiness) {
                    runWithSigRefCheck({
                        act: 'receiptDraftMultiple',
                        paymentIds: [payment.id],
                        selectedClientCaseId: payment.caseId,
                        receiptDate: selectedDate
                    });
                } else {
                    generateReceiptDraftMultiple([payment.id], payment.caseId, selectedDate);
                }

                // Clear selection after successful generation
                setPickedPayments([]);
                setPaymentActionMode(null);
                toast.success(t('ReceiptGeneratedSuccessfully'));
            }
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsGenerating(false);
        }
    };

    const handleGenerateReceiptsDraft = async () => {
        if (!pickedPayments.length || isGenerating || isDraftingReceiptDrafts || isDraftingLedgerInvoices) return;

        setIsGenerating(true);
        try {
            // Show date selection dialog
            const result = await Swal.fire({
                title: '?' + t('GenerateReceipt'),
                html: `
                    <p>${t('WouldYouLikeToGenerateAReceiptForSelectedPayments')}</p>
                    <div style="margin-top: 15px;">
                        <label for="receipt-date-selected" style="display: block; margin-bottom: 5px; font-weight: bold;">${t('ReceiptDate')}:</label>
                        <input type="date" id="receipt-date-selected" class="swal2-input" style="width: 100%;" value="${new Date().toISOString().split('T')[0]}">
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('Yes'),
                cancelButtonText: t('No'),
                preConfirm: () => {
                    const dateInput = document.getElementById('receipt-date-selected');
                    const selectedDate = dateInput.value;
                    if (!selectedDate) {
                        Swal.showValidationMessage(t('PleaseSelectADate'));
                        return false;
                    }
                    return selectedDate;
                }
            });

            if (result.isConfirmed) {
                const selectedDate = result.value;

                // One receipt per selected payment row (bulk endpoint; supports multi-caseId)
                const jobs = pickedPayments.map((payment) => ({
                    paymentIds: [payment.id],
                    caseId: payment.caseId,
                    clientName: caseIdToName?.[payment.caseId] || payment.clientName || payment.name || null,
                    amount: Number(payment.amount) || 0,
                    receiptDate: selectedDate,
                }));

                const { needSig, needRef } = await signatureChecklist('receipt');
                if (needSig || needRef) {
                    await runWithSigRefCheck({ act: 'receiptDraftMultipleBulk', jobs });
                } else {
                    await dispatchReceiptDraftBulkPreview(jobs);
                }

                // Clear selection after successful generation
                setPickedPayments([]);
                setPaymentActionMode(null);
                toast.success(t('ReceiptsGeneratedSuccessfully'));
            }
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsGenerating(false);
        }
    };

    const handleGenerateReceiptsFinalBulk = async () => {
        if (!pickedPayments.length || isGenerating) return;

        setIsGenerating(true);
        try {
            const result = await Swal.fire({
                title: '?' + t('GenerateReceipt'),
                html: `
                    <p>${t('WouldYouLikeToGenerateAReceiptForSelectedPayments')}</p>
                    <div style="margin-top: 15px;">
                        <label for="receipt-date-selected-final" style="display: block; margin-bottom: 5px; font-weight: bold;">${t('ReceiptDate')}:</label>
                        <input type="date" id="receipt-date-selected-final" class="swal2-input" style="width: 100%;" value="${new Date().toISOString().split('T')[0]}">
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('Yes'),
                cancelButtonText: t('No'),
                preConfirm: () => {
                    const dateInput = document.getElementById('receipt-date-selected-final');
                    const selectedDate = dateInput.value;
                    if (!selectedDate) {
                        Swal.showValidationMessage(t('PleaseSelectADate'));
                        return false;
                    }
                    return selectedDate;
                }
            });

            if (result.isConfirmed) {
                const selectedDate = result.value;

                const jobs = pickedPayments.map((payment) => ({
                    paymentIds: [payment.id],
                    caseId: payment.caseId,
                    clientName: caseIdToName?.[payment.caseId] || payment.clientName || payment.name || null,
                    amount: Number(payment.amount) || 0,
                    receiptDate: selectedDate,
                }));

                const { needSig, needRef } = await signatureChecklist('receipt');
                if (needSig || needRef) {
                    await runWithSigRefCheck({ act: 'receiptFinalMultipleBulk', jobs });
                } else {
                    await dispatchReceiptFinalBulkPreview(jobs);
                }

                setPickedPayments([]);
                setPaymentActionMode(null);
            }
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setIsGenerating(false);
        }
    };

    const handleAddItem = async (newItem) => {
        try {
            let response;
            let created;

            // Check if newItem is an array (multiple payments) or single item
            if (Array.isArray(newItem)) {
                // Handle multiple payments
                if (itemType === 'payments') {
                    const multiplePaymentsDto = {
                        caseId: newItem[0].caseId,
                        payments: newItem.map(payment => ({
                            type: parseInt(payment.type, 10),
                            date: payment.date,
                            amount: payment.amount,
                            description: payment.description,
                            reference: payment.reference,
                            bankName: payment.bankName ?? null,
                            bankCode: payment.bankCode ?? null,
                            bankBranchCode: payment.bankBranchCode ?? null,
                            supplierAccountNumber: payment.supplierAccountNumber ?? null
                        }))
                    };

                    response = await EnumsService.AddMultiplePayments(multiplePaymentsDto, token);
                    
                    if (response.ok) {
                        created = await response.json();
                        setNewPaymentDetails(created);
                        fetchEnums(null, token, client, null, null);
                        handleCloseDialog();
                        
                        // Ask for receipt if multiple payments were created
                        const result = await Swal.fire({
                            title: '?' + t('GenerateReceipt'),
                            html: `
                                <p>${t('WouldYouLikeToGenerateAReceiptForAllPayments')}</p>
                                <div style="margin-top: 15px;" dir="${i18n.dir()}" style="text-align: ${i18n.dir() === 'rtl' ? 'right' : 'left'}">
                                    <label for="receipt-date-multiple" style="display: block; margin-bottom: 5px; font-weight: bold;">${t('ReceiptDate')}:</label>
                                    <input type="date" id="receipt-date-multiple" class="swal2-input"  value="${new Date().toISOString().split('T')[0]}">
                                </div>
                            `,
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonText: t('Yes'),
                            cancelButtonText: t('No'),
                            preConfirm: () => {
                                const dateInput = document.getElementById('receipt-date-multiple');
                                const selectedDate = dateInput.value;
                                if (!selectedDate) {
                                    Swal.showValidationMessage(t('PleaseSelectADate'));
                                    return false;
                                }
                                return selectedDate;
                            }
                        });

                        if (result.isConfirmed) {
                            const selectedDate = result.value;
                            // Generate receipt for all multiple payments regardless of client type
                            const paymentIds = created.map(payment => payment.id);
                            
                            // Add a small delay to ensure database transaction is committed
                            setTimeout(() => {
                                if (client.leadingBusiness) {
                                    // For leading business, pass the selected client's caseId
                                    runWithSigRefCheck(
                                        { act: 'receiptDraftMultiple', paymentIds: paymentIds, selectedClientCaseId: newItem[0].caseId, receiptDate: selectedDate }
                                    );
                                } else {
                                    // For non-leading business, pass the client caseId where payments were created
                                    generateReceiptDraftMultiple(paymentIds, newItem[0].caseId, selectedDate);
                                }
                            }, 100); // 100ms delay
                        }
                    } else {
                        const errorText = await response.text();
                        console.error(`Failed to add multiple payments:`, errorText);
                        toast.error(t('FailedToAddMultiplePayments'));
                    }
                } else {
                    console.error(`Multiple items not supported for item type: ${itemType}`);
                    return;
                }
            } else {
                // Handle single item (existing logic)
            const collectionPageId =
                newItem.id            // set when the leading-business dropdown is used
                    ? newItem.id
                    : collectionPageData.id;

            if (itemType === 'monthlyCharges') {
                // Adjust dates to first day of the month in UTC
                let adjustedStartDate = newItem.startDate;
                if (adjustedStartDate) {
                    const startDateObj = new Date(adjustedStartDate);
                    adjustedStartDate = new Date(Date.UTC(startDateObj.getUTCFullYear(), startDateObj.getUTCMonth(), 1));
                }
                
                let adjustedEndDate = newItem.endDate;
                if (adjustedEndDate) {
                    const endDateObj = new Date(adjustedEndDate);
                    adjustedEndDate = new Date(Date.UTC(endDateObj.getUTCFullYear(), endDateObj.getUTCMonth(), 1));
                }
                
                response = await EnumsService.AddMonthlyCharge(
                    collectionPageId,
                    adjustedStartDate,
                    adjustedEndDate,
                    newItem.amount,
                    newItem.description,
                    newItem.caseId,
                    token
                );
            } else if (itemType === 'oneTimeCharges') {
                response = await EnumsService.AddOneTimeCharge(
                    collectionPageId,
                    newItem.date,
                    newItem.amount,
                    newItem.description,
                    newItem.caseId,
                    token
                );
            } else if (itemType === 'payments') {
                response = await EnumsService.AddPayment(
                    collectionPageId,
                    parseInt(newItem.type, 10),
                    newItem.date,
                    newItem.amount,
                    newItem.description,
                    newItem.reference,
                    newItem.caseId,
                        newItem.bankName ?? null,
                        newItem.bankCode ?? null,
                        newItem.bankBranchCode ?? null,
                    newItem.supplierAccountNumber ?? null,
                    token
                );
            } else {
                console.error(`Unknown item type: ${itemType}`);
                return;
            }

            if (response.ok) {
                    created = await response.json();
                setNewPaymentDetails(created);
                fetchEnums(null, token, client, null, null);
                handleCloseDialog();
                    
                // ask for receipt if a payment was just created
                if (itemType === 'payments') {
                    const result = await Swal.fire({
                        title: '?' + t('GenerateReceipt'),
                        html: `
                            <p>${t('WouldYouLikeToGenerateAReceiptNow')}</p>
                            <div style="margin-top: 15px;">
                                <label for="receipt-date" style="display: block; margin-bottom: 5px; font-weight: bold;">${t('ReceiptDate')}:</label>
                                <input type="date" id="receipt-date" class="swal2-input" style="width: 100%;" value="${new Date().toISOString().split('T')[0]}">
                            </div>
                        `,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: t('Yes'),
                        cancelButtonText: t('No'),
                        preConfirm: () => {
                            const dateInput = document.getElementById('receipt-date');
                            const selectedDate = dateInput.value;
                            if (!selectedDate) {
                                Swal.showValidationMessage(t('PleaseSelectADate'));
                                return false;
                            }
                            return selectedDate;
                        }
                    });

                    if (result.isConfirmed) {
                        const selectedDate = result.value;
                        if (client.leadingBusiness) {
                            runWithSigRefCheck(
                                { act: 'receiptDraftMultiple', paymentIds: [created.paymentId], selectedClientCaseId: newItem[0].caseId, receiptDate: selectedDate }
                            );
                        } else {
                            generateReceiptDraftMultiple([created.paymentId], newItem[0].caseId, selectedDate);
                        }
                    }
                }
            } else {
                const errorText = await response.text();
                console.error(`Failed to add item to ${itemType}:`, errorText);
                }
            }
        } catch (error) {
            console.error(`Error adding item to ${itemType}:`, error);
        } finally {
            handleCloseDialog();
        }
    };


    /**
     * Bulk-import payments coming from an Excel file.
     * Rows may belong to different clients (caseId is the key), so we group
     * them and call the multi-payment endpoint once per caseId.
     * Returns true on full success so the importer UI can clear itself.
     */
    const handleExcelImportPayments = async (rows) => {
        if (!Array.isArray(rows) || rows.length === 0) return false;

        // Guardrail: only accept caseIds that truly belong to this accountant.
        // - Leading business: caseId must match one of the loaded sub-clients.
        // - Non-leading: caseId must match the current open client.
        const allowedCaseIds = new Set(
            client?.leadingBusiness
                ? (caseIdOptions || []).map((c) => String(c.value))
                : [String(client?.caseId)].filter(Boolean)
        );

        // Group rows by caseId (fallback to currently-open client's caseId)
        const groups = new Map(); // caseId -> payments[]
        let rejected = 0;
        for (const p of rows) {
            const key = String(p.caseId || client?.caseId || collectionPageData?.caseId || '');
            if (!key) { rejected += 1; continue; }
            if (allowedCaseIds.size > 0 && !allowedCaseIds.has(key)) { rejected += 1; continue; }
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(p);
        }

        if (rejected > 0) {
            toast.error(
                `${t('CaseIdNotUnderAccountant') || t('InvalidCaseId')} (${rejected})`
            );
        }

        if (groups.size === 0) {
            toast.error(t('NoValidRowsToImport') || t('ImportFailed'));
            return false;
        }

        setLoading(true);
        let successCount = 0;
        let failureCount = 0;
        const createdPaymentIdsByCase = new Map(); // caseId -> [paymentId]

        try {
            for (const [caseId, payments] of groups.entries()) {
                const dto = {
                    caseId,
                    payments: payments.map((payment) => {
                        // Align with the manual multi-payment flow: DB stores the
                        // VAT-inclusive amount. If the user marked the amount as
                        // net (priceIncludingVAT=false) we gross it up by VAT.
                        const raw = Number(payment.amount) || 0;
                        const includes = payment.priceIncludingVAT ?? true;
                        const vatRate = getVatValue(payment.date);
                        const amountOut = includes ? raw : raw * (1 + vatRate);

                        return {
                            type: parseInt(payment.type, 10),
                            date: payment.date,
                            amount: amountOut,
                            description: payment.description,
                            reference: payment.reference,
                            bankName: payment.bankName ?? null,
                            bankCode: payment.bankCode ?? null,
                            bankBranchCode: payment.bankBranchCode ?? null,
                            supplierAccountNumber: payment.supplierAccountNumber ?? null,
                        };
                    }),
                };

                try {
                    const response = await EnumsService.AddMultiplePayments(dto, token);
                    if (response.ok) {
                        const created = await response.json();
                        successCount += Array.isArray(created) ? created.length : payments.length;
                        if (Array.isArray(created)) {
                            createdPaymentIdsByCase.set(caseId, created.map((c) => c.id).filter(Boolean));
                        }
                    } else {
                        failureCount += payments.length;
                        const err = await response.text();
                        console.error(`Import failed for caseId ${caseId}:`, err);
                    }
                } catch (err) {
                    failureCount += payments.length;
                    console.error(`Error importing payments for caseId ${caseId}:`, err);
                }
            }

            if (successCount > 0) {
                toast.success(`${t('ImportSuccessful')} (${successCount})`);
                fetchEnums(null, token, client, null, null);
            }
            if (failureCount > 0) {
                toast.error(`${t('ImportFailed')} (${failureCount})`);
            }

            return failureCount === 0 && successCount > 0;
        } finally {
            setLoading(false);
        }
    };

    // Called by the monthly-charges import modal after a commit attempt. Toasts a summary
    // and refetches the collection data so the new charges appear.
    const handleMonthlyChargesImported = ({ processed = 0, errors = 0, skipped = 0 } = {}) => {
        if (processed > 0) {
            toast.success(`${t('ImportSuccessful')} (${processed})`);
            fetchEnums(null, token, client, null, null);
        }
        const failed = (errors || 0) + (skipped || 0);
        if (failed > 0) {
            toast.error(`${t('ImportFailed')} (${failed})`);
        }
        if (processed === 0 && failed === 0) {
            toast.error(t('NoValidRowsToImport') || t('ImportFailed'));
        }
    };

    const handleStartDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        localStorage.setItem('StartDate', newDate);
        setEndDate(newDate);
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }




        localStorage.setItem('EndDate', updatedDate)
        setEndDate(updatedDate);
    };

    useEffect(() => {
        if (endDate && client && token) {
            fetchEnums(null, token, client, null, null);
        }
    }, [endDate]);

    useEffect(() => {
        if (client?.leadingBusiness && token && user) {
            fetchEnums(user, token, client, null, null);     // re-fetch with the new filter
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCaseIds]);

    // Date filter handlers
    const handleDateFilterModeChange = (newMode) => {
        setDateFilterMode(newMode);
        
        if (client && token) {
            // Refetch with new mode, passing it explicitly to avoid stale state
            fetchEnums(user, token, client, null, null, newMode);
        }
    };

    const handleFilterMonthChange = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getUTCFullYear(), endDate.getUTCMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getUTCFullYear(), newDate.getUTCMonth(), 10));
        }
        localStorage.setItem('FilterMonth', updatedDate);
        setFilterMonth(updatedDate);
        // Refetch data with new month filter, passing the new date explicitly
        if (dateFilterMode === 'monthOnly' && updatedDate && client && token) {
            fetchEnums(user, token, client, null, null, null, updatedDate);
        }
    };

    const handleEndDateFilterChange = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDateFilter.getMonth() + 1, 0));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDateFilter.getFullYear(), newDate.getMonth() + 1, 0));
        }

        setEndDateFilter(updatedDate);
        // Refetch data with new till date filter, passing the new date explicitly
        if (dateFilterMode === 'tillDate' && updatedDate && client && token) {
            fetchEnums(user, token, client, null, null, null, null, updatedDate);
        }
    };


    const handleClickedDelete = (id) => {
        setIdToDelete(id);
        setDialogOpen(false);
        setDeleteModalVisable(true);
    }

    const allVisiblePayments = useMemo(() => filteredData.p, [filteredData]);
    const selectablePayments = useMemo(() => {
        if (!paymentActionMode) return [];
        if (paymentActionMode === 'receipt') return allVisiblePayments.filter(row => !row.receiptId);
        if (paymentActionMode === 'invoice') return allVisiblePayments.filter(row => !row.invoiceId);
        if (paymentActionMode === 'close') return allVisiblePayments.filter(row => !row.isClosed);
        if (paymentActionMode === 'reopen') return allVisiblePayments.filter(row => row.isClosed);
        return [];
    }, [allVisiblePayments, paymentActionMode]);
    const allChecked =
        (paymentActionMode === 'invoice' || paymentActionMode === 'receipt' || paymentActionMode === 'close' || paymentActionMode === 'reopen') &&
        pickedPayments.length === selectablePayments.length &&
        selectablePayments.length > 0;
    const someChecked =
        (paymentActionMode === 'invoice' || paymentActionMode === 'receipt' || paymentActionMode === 'close' || paymentActionMode === 'reopen') &&
        pickedPayments.length > 0 &&
        !allChecked;

    const handleToggleAll = (checked) => {
        setPickedPayments(checked ? selectablePayments : []);
    };


    const openInvoiceOfPayment = async (invoiceId) => {

        try {
            const resp = await DocumentService.GetDocumentUrlById(invoiceId, token);
            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return;
            }
            const { url } = await resp.json();
            setIframeUrl(url);
            setBigIframeModalOpen(true);         // ← open the draggable viewer
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        }
    };

    const openRecieptOfPayment = async (invoiceId) => {

        try {
            const resp = await DocumentService.GetPaymentAcceptanceDocumentUrlById(invoiceId, token);
            if (!resp.ok) {
                toast.error(t('TaskFailed'));
                return;
            }
            const { url } = await resp.json();
            setIframeUrl(url);
            setBigIframeModalOpen(true);         // ← open the draggable viewer
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        }
    };

    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');
    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setIframeUrl('');
    };

    /**
     * @param {'invoiceDraft'|'invoiceFinal'|'receiptDraft'|'receiptFinal'} action
     *        choose **exactly** the function below that you already have.
     */
    const runWithSigRefCheck = async (action) => {
        const docType = action.act.startsWith('invoice') ? 'invoice' : 'receipt';
        const { needSig, needRef } = await signatureChecklist(docType);

        if (needSig || needRef) {
            setNeedSig(needSig);
            setNeedRef(needRef);
            pendingAction.current = action;
            setSigRefModalOpen(true);          // 🚪 open the dialog
        } else {
            // we already have everything → run immediately
            launchAction(action);
        }
    };

    /* Actually run the existing code that you already have */
    const launchAction = (action) => {

        switch (action.act) {
            case 'invoiceDraft': handleGenerateInvoicesDraft(invoiceSignature, invoiceReference, action.invoiceDate); break;
            case 'receiptDraftMultiple': generateReceiptDraftMultiple(action.paymentIds, action.selectedClientCaseId, action.receiptDate); break;
            case 'receiptFinalMultiple': generateReceiptFinalMultiple(action.paymentIds, action.selectedClientCaseId); break;
            case 'receiptDraftMultipleBulk':
                (async () => {
                    await dispatchReceiptDraftBulkPreview(action.jobs || []);
                })();
                break;
            case 'receiptFinalMultipleBulk':
                (async () => {
                    await dispatchReceiptFinalBulkPreview(action.jobs || []);
                })();
                break;

            default: console.warn('unknown action', action);
        }
    };

    const handleSigRefSave = () => {
        if (needSig && !invoiceSignature) { toast.error(t('ProvideSignature')); return; }
        if (needRef && !invoiceReference) { toast.error(t('ProvideReference')); return; }

        setSigRefModalOpen(false);
        // run the postponed action
        if (pendingAction.current) launchAction(pendingAction.current);
    };

    /* user clicked "Cancel / Close" */
    const handleSigRefClose = () => {
        setSigRefModalOpen(false);
        pendingAction.current = null;
    };

    /* Clear payment action mode when client is not leading business */
    useEffect(() => {
        if (!client?.leadingBusiness) {
            setPaymentActionMode(null);
            setPickedPayments([]);
        }
    }, [client?.leadingBusiness]);

    const handleTaxAuthorityOptionSelect = (decisionFlag) => {
        if (decisionFlag !== undefined && decisionFlag !== null) {
            handleGenerateInvoicesFinal(true, decisionFlag);
        }
    };

    /* ───────── table → Excel exports (WYSIWYG of the on-screen grids) ───────── */
    const [downloadingMonthlyExcel, setDownloadingMonthlyExcel] = useState(false);
    const [downloadingPaymentsExcel, setDownloadingPaymentsExcel] = useState(false);

    /** Resolve the "created by" cell exactly like the grid column does. */
    const resolveCreatedByLabel = (row) => {
        const uid = row?.createdByUserId;
        const utype = row?.createdByUserType;
        if (!uid && !utype) return '';
        const found = subAccountantOptions?.find((option) => option.value === uid);
        if (found?.label) return found.label;
        if (utype === 'Client') return t('Client');
        return uid && utype ? `${uid} (${utype})` : (uid || utype || '');
    };

    /** Human-readable period matching the active date filter (used as the Excel sub-title). */
    const buildExportPeriodLabel = () =>
        dateFilterMode === 'monthOnly'
            ? dayjs(filterMonth).format('MM/YYYY')
            : `${t('TillDate', { defaultValue: 'עד' })} ${dayjs(endDateFilter).format('MM/YYYY')}`;

    const paymentTypeLabel = (value) => {
        const option = PaymentTypeOptions.find((opt) => opt.value == value);
        return option ? option.name : String(value ?? '');
    };

    const buildCanceledStatusLabel = (row) => {
        const parts = [];
        if (row.invoiceIsCanceled) parts.push(t('CanceledInvoice'));
        if (row.receiptIsCanceled) parts.push(t('CanceledReceipt'));
        if (row.isCanceledManually) parts.push(t('CanceledManually'));
        return parts.length ? parts.join(' / ') : '';
    };

    const handleDownloadMonthlyChargesExcel = async () => {
        if (downloadingMonthlyExcel) return;
        setDownloadingMonthlyExcel(true);
        try {
            const rows = (filteredData.m || []).map((r) => ({
                clientName: caseIdToName[r.caseId] || '',
                caseId: r.caseId || '',
                startDate: formatDate2(r.startDate),
                endDate: formatDate2(r.endDate),
                amount: Number(r.amount) || 0,
                description: r.description || '',
                createdBy: resolveCreatedByLabel(r),
            }));

            // Only DATA is sent; the title, column headers and totals labels are
            // owned by the server (LedgerHtmlService), like ExcelClientService's template.
            const payload = {
                leadingBusiness: !!client?.leadingBusiness,
                period: buildExportPeriodLabel(),
                total: (summaryTotals.monthlyCharges || 0) * -1,
                rows,
            };

            const blob = await ledgerReportsService.downloadMonthlyChargesTableExcel(payload);
            ledgerReportsService.downloadFile(blob, `חיובים-חודשיים-${dayjs().format('DD-MM-YYYY')}.xlsx`);
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setDownloadingMonthlyExcel(false);
        }
    };

    const handleDownloadPaymentsExcel = async () => {
        if (downloadingPaymentsExcel) return;
        setDownloadingPaymentsExcel(true);
        try {
            const rows = (filteredData.p || []).map((r) => ({
                clientName: caseIdToName[r.caseId] || '',
                caseId: r.caseId || '',
                type: paymentTypeLabel(r.type),
                date: formatDate3(r.date),
                invoiceCreated: r.invoiceId ? t('Yes') : t('No'),
                receiptCreated: r.receiptId ? t('Yes') : t('No'),
                amount: Number(r.amount) || 0,
                status: r.isClosed ? t('Closed') : t('Open'),
                canceledStatus: buildCanceledStatusLabel(r),
                createdBy: resolveCreatedByLabel(r),
                description: r.description || '',
                reference: r.reference || '',
            }));

            // Only DATA is sent; the title, column headers and totals labels are
            // owned by the server (LedgerHtmlService), like ExcelClientService's template.
            const payload = {
                leadingBusiness: !!client?.leadingBusiness,
                period: buildExportPeriodLabel(),
                total: summaryTotals.payments || 0,
                rows,
            };

            const blob = await ledgerReportsService.downloadPaymentsTableExcel(payload);
            ledgerReportsService.downloadFile(blob, `תקבולים-${dayjs().format('DD-MM-YYYY')}.xlsx`);
        } catch (err) {
            console.error(err);
            toast.error(t('TaskFailed'));
        } finally {
            setDownloadingPaymentsExcel(false);
        }
    };

    const handlePreviewCancel = () => {
        setPreviewOpen(false);
        setPdfResults([]);
        setBlobUrl('');
        setPreviewKind('invoice');
        setReceiptBulkJobs([]);
    };

    const handlePreviewConfirm = () => {
        if (previewKind === 'receipt') {
            // Step 2 for receipts: user approved drafts → generate final receipts for same jobs
            setPreviewOpen(false);
            setPdfResults([]);
            setBlobUrl('');
            dispatchReceiptFinalBulkPreview(receiptBulkJobs);
            setReceiptBulkJobs([]);
            setPreviewKind('invoice');
            return;
        }

        handleGenerateInvoicesFinal();
    };

    const collectionButtonData = useMemo(() => [
        {
            label: 'GenerateLedgerReports',
            onClick: () => setLedgerReportsModalOpen(true),
        },
        {
            label: 'GenerateMasavFile',
            onClick: handleGenerateMasavClick,
            show: !!client?.leadingBusiness,
        },
        {
            label: 'PaymentArrangements',
            onClick: () => setPaymentArrangementsModalOpen(true),
            show: !!client?.leadingBusiness,
        },
        {
            label: 'GenerationLogs',
            onClick: () => setGenerationLogsModalOpen(true),
            show: !!client?.leadingBusiness,
        },
        {
            label: 'ImportPaymentsFromExcel',
            onClick: () => setPaymentsExcelImportModalOpen(true),
            style: { width: '200px', minWidth: '200px', maxWidth: '200px' },
        },
        {
            label: 'ImportMonthlyChargesFromExcel',
            onClick: () => setMonthlyChargesImportModalOpen(true),
            style: { width: '220px', minWidth: '220px', maxWidth: '220px' },
        },
        {
            label: 'SavedCards.manage',
            onClick: () => {
                setSavedCardsForceCaseId(client?.leadingBusiness ? null : (client?.caseId || null));
                setSavedCardsModalOpen(true);
            },
            show: creditTerminalApproved,
            variant: 'outline',
            style: { width: '220px', minWidth: '220px', maxWidth: '220px' },
        },
        {
            label: 'CreditCardBulkCharge.openButton',
            onClick: () => setCreditCardChargeOpen(true),
            show: creditTerminalApproved,
            variant: 'accent',
        },
    ], [client?.leadingBusiness, client?.caseId, creditTerminalApproved, handleGenerateMasavClick]);

    return (
        <>
            {(isDraftingLedgerInvoices || isDraftingReceiptDrafts) && (
                <LinearProgress
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 4000,
                        height: 4,
                        '& .MuiLinearProgress-bar': { backgroundColor: '#E57C22' },
                    }}
                />
            )}
            <SignatureReferenceModal
                isVisible={sigRefModalOpen}
                onSave={handleSigRefSave}
                onClose={handleSigRefClose}
                direction={i18n.dir()}
                invoiceSignature={invoiceSignature}
                setInvoiceSignature={setInvoiceSignature}
                invoiceReference={invoiceReference}
                setInvoiceReference={setInvoiceReference}
                needSignature={needSig}
                needReference={needRef}
                type={needRef ? t('Reference') : t('Signature')}
            />


            {/* delete modal, top-level loaders etc. untouched */}
            <CustomDeleteConfirmationModal
                isVisible={deleteModalVisable}
                onClose={() => setDeleteModalVisable(false)}
                onDelete={handleDeleteItem}
            />

            <Modal
                open={draftPdfModalVisible}
                onClose={handleCloseDraftPdf}
            >
                <div
                    className="draft-pdf-modal-container"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '85%',
                        background: '#fff',          // keeps the iframe readable
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 4px 24px rgba(0,0,0,.35)'
                    }}
                >
                    {draftPdfBlob && (
                        <iframe
                            src={URL.createObjectURL(draftPdfBlob)}
                            style={{ flex: 1, border: 'none' }}
                            title="draft-receipt"
                        />
                    )}

                    <div className="draft-pdf-button-container" style={{ padding: 16, textAlign: 'center' }}>
                        {!isFinalReciept && (
                            <button className="create-invoice-button" disabled={isGeneratingReceipts} onClick={() => {
                                if (isMultiplePayments) {
                                    generateReceiptFinalMultiple(
                                        multiplePaymentIds,
                                        selectedClientCaseId,
                                        currentReceiptDraftReference
                                    );
                                } else {
                                    generateReceiptFinalMultiple([newPaymentDetails.paymentId], client.caseId);
                                }
                            }}>
                                {isGeneratingReceipts ? t('Generating') : t('menu.generateReceipt')}
                            </button>
                        )}
                        <button className="close-invoice-button" onClick={handleCloseDraftPdf}>
                            {!isFinalReciept ? t('Cancel') : t('Close')}
                        </button>

                    </div>
                </div>
            </Modal>


            <MultipleDraftPdfPreview
                open={previewOpen}
                results={pdfResults}
                onCancel={handlePreviewCancel}
                onOk={handlePreviewConfirm}
                confirmLoading={isGenerating || isGeneratingReceipts}
                t={t}
                okLabel={previewKind === 'receipt' ? t('menu.generateReceipt') : t('OK')}
                title={previewKind === 'receipt' ? t('GenerateReceipts') : t('GenerateInvoices')}
            />

            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={iframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />



            <>
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }} dir={direction}>
                        <NavigationButton
                            t={t}
                            direction={direction}
                            data={collectionButtonData}
                        />
                    </Box>

                    <MasavPaymentDayNotice
                        accountantId={client?.accountantId}
                        caseId={client?.caseId}
                        isLeadingBusiness={!!client?.leadingBusiness}
                        pending={masavPendingPaymentDays}
                        sx={{ mt: 1.25 }}
                    />

                    {/* ───────── financial summary totals ───────── */}
                    <div className={cs.summaryBar} dir={direction}>
                        {[
                            { key: 'monthly', label: t('MonthlyCharges'), value: summaryTotals.monthlyCharges * -1, tone: cs.summaryDebit },
                            { key: 'oneTime', label: t('OneTimeCharges'), value: summaryTotals.oneTimeCharges * -1, tone: cs.summaryDebit },
                            { key: 'payments', label: t('Acceptances'), value: summaryTotals.payments, tone: cs.summaryCredit },
                            {
                                key: 'total',
                                label: t('GrandTotal'),
                                value: summaryTotals.total,
                                tone: `${summaryTotals.total > 0 ? cs.summaryCredit : cs.summaryDebit} ${cs.summaryBalance}`,
                            },
                        ].map((item) => (
                            <div key={item.key} className={`${cs.summaryCard} ${item.tone}`}>
                                <span className={cs.summaryLabel}>{item.label}</span>
                                <span className={cs.summaryValue}>
                                    {beautifyNumber(item.value).trim()}
                                    <span className={cs.summaryCurrency}>₪</span>
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}`}>
                        <Box className="document-filter-row" dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('Search')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="document-search-bar"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className="document-search-icon" />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Box className="document-data-view">
                                <ToggleButtonGroup
                                    value={dateFilterMode}
                                    exclusive
                                    onChange={(_, newValue) => {
                                        if (newValue) handleDateFilterModeChange(newValue);
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="monthOnly" aria-label={t('MonthOnly') || 'Month only'}>
                                        {t('MonthOnly') || 'Month only'}
                                    </ToggleButton>
                                    <ToggleButton value="tillDate" aria-label={t('TillDate') || 'Till date'}>
                                        {t('TillDate') || 'Till date'}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>

                            <div className={headerStyles.dateSelect}>
                                {dateFilterMode === 'monthOnly' ? (
                                    <FilterMonthYearPicker
                                        year={filterMonth}
                                        month={filterMonth}
                                        onYearChange={(y) => handleFilterMonthChange(y, 'year')}
                                        onMonthChange={(m) => handleFilterMonthChange(m, 'month')}
                                        labelYear={t('Year')}
                                        labelMonth={t('Month')}
                                        direction={direction}
                                    />
                                ) : (
                                    <FilterMonthYearPicker
                                        year={endDateFilter}
                                        month={endDateFilter}
                                        onYearChange={(y) => handleEndDateFilterChange(y, 'year')}
                                        onMonthChange={(m) => handleEndDateFilterChange(m, 'month')}
                                        labelYear={t('TillYear') || t('Year')}
                                        labelMonth={t('TillMonth') || t('Month')}
                                        direction={direction}
                                    />
                                )}
                            </div>

                            {client?.leadingBusiness && (
                                <>
                                    <Box sx={{ width: 240, flexShrink: 0, minWidth: 200 }}>
                                        <AutocompleteSelectFilter
                                            key={selectedCaseIds[0]?.value ?? 'empty'}
                                            options={caseIdOptions}
                                            selectedValues={
                                                selectedCaseIds[0]
                                                    ? caseIdOptions.find(
                                                        (opt) => opt.value === selectedCaseIds[0].value
                                                    )
                                                    : null
                                            }
                                            onChange={(_, val) => setSelectedCaseIds(val ? [val] : [])}
                                            placeholder={t('Client Name')}
                                            isMultiple={false}
                                            direction={direction}
                                            searchable
                                            portalMenu
                                            clearable
                                        />
                                    </Box>
                                    <Box sx={{ width: 160, flexShrink: 0 }}>
                                        <AutocompleteSelectFilter
                                            options={docFilterOptions}
                                            selectedValues={
                                                docFilterOptions.find((option) => option?.value === docFilter) || null
                                            }
                                            onChange={(_, val) => setDocFilter(val?.value ?? '')}
                                            label={t('Document')}
                                            placeholder={t('SelectDocumentType')}
                                            isMultiple={false}
                                            searchable
                                            direction={direction}
                                            portalMenu
                                            clearable
                                        />
                                    </Box>
                                    <Box sx={{ width: 160, flexShrink: 0 }}>
                                        <AutocompleteSelectFilter
                                            options={paymentStatusFilterOptions}
                                            selectedValues={
                                                paymentStatusFilterOptions.find((option) => option?.value === paymentStatusFilter) || null
                                            }
                                            onChange={(_, val) => setPaymentStatusFilter(val?.value ?? 'all')}
                                            label={t('PaymentStatus')}
                                            placeholder={t('SelectPaymentStatus')}
                                            isMultiple={false}
                                            searchable
                                            direction={direction}
                                            portalMenu
                                        />
                                    </Box>
                                    {(selectedCaseIds.length > 0 || docFilter || paymentStatusFilter !== 'all' || searchQuery) && (
                                        <Tooltip title={t('Clear') || 'Clear'}>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setSelectedCaseIds([]);
                                                    setDocFilter('');
                                                    setPaymentStatusFilter('all');
                                                    setSearchQuery('');
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </>
                            )}
                        </Box>
                    </div>

                    {/* --------------- MAIN SECTION --------------- */}
                    <div
                        className="table-container"
                        style={{ overflowX: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                    >
                        {/* Outer box keeps vertical flow for the date-picker, then tables row */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, py: 1.25, width: '100%' }}>
                            <div className={`${cs.tablesRow} ${expandedTable ? cs.tablesRowExpanded : ''}`}>
                                {/* =============== Monthly Charges =============== */}
                                {isTableVisible('monthly') && (
                                <div className={cs.section}>
                                    <div className={cs.sectionHeader}>
                                        <div className={cs.sectionTitleGroup}>
                                            <h3 className={cs.sectionTitle}>{t('MonthlyCharges')}</h3>
                                            <span className={`${cs.totalPill} ${cs.totalDebit}`}>
                                                {t('Total')}
                                                <b>{beautifyNumber(summaryTotals.monthlyCharges * -1)}</b>
                                            </span>
                                        </div>
                                        <div className={cs.sectionActions}>
                                            <Tooltip title={t('ExportToExcel', { defaultValue: 'ייצוא לאקסל' })}>
                                                <span>
                                                    <XBtn
                                                        variant="excel"
                                                        className={cs.btnIcon}
                                                        onClick={handleDownloadMonthlyChargesExcel}
                                                        disabled={downloadingMonthlyExcel || !(filteredData.m || []).length}
                                                        loading={downloadingMonthlyExcel}
                                                        icon={<DownloadIconMui />}
                                                    />
                                                </span>
                                            </Tooltip>
                                            <XBtn
                                                variant="primary"
                                                onClick={() => handleOpenDialog('monthlyCharges')}
                                                icon={<AddCircleIcon />}
                                            >
                                                {t('Add')}
                                            </XBtn>
                                            <ExpandToggle
                                                t={t}
                                                expanded={expandedTable === 'monthly'}
                                                onClick={() => toggleExpandedTable('monthly')}
                                            />
                                        </div>
                                    </div>
                                    <div className={cs.gridWrap}>
                                        <StyledDataGrid
                                            rows={filteredData.m || []} // m = monthly charges
                                            columns={monthlyChargesColumns}
                                            pageSize={expandedTable === 'monthly' ? 20 : 5}
                                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                            style={{ height: expandedTable === 'monthly' ? '75vh' : '60vh' }}
                                            rowHeight={46}
                                            disableRowSelectionOnClick
                                            components={{ Toolbar: GridToolbar }}
                                        />
                                    </div>
                                </div>
                                )}

                                {/* =============== One-Time Charges =============== */}
                                {isTableVisible('oneTime') && (
                                <div className={cs.section}>
                                    <div className={cs.sectionHeader}>
                                        <div className={cs.sectionTitleGroup}>
                                            <h3 className={cs.sectionTitle}>{t('OneTimeCharges')}</h3>
                                            <span className={`${cs.totalPill} ${cs.totalDebit}`}>
                                                {t('Total')}
                                                <b>{beautifyNumber(summaryTotals.oneTimeCharges * -1)}</b>
                                            </span>
                                        </div>
                                        <div className={cs.sectionActions}>
                                            <XBtn
                                                variant="primary"
                                                onClick={() => handleOpenDialog('oneTimeCharges')}
                                                icon={<AddCircleIcon />}
                                            >
                                                {t('Add')}
                                            </XBtn>
                                            <ExpandToggle
                                                t={t}
                                                expanded={expandedTable === 'oneTime'}
                                                onClick={() => toggleExpandedTable('oneTime')}
                                            />
                                        </div>
                                    </div>
                                    <div className={cs.gridWrap}>
                                        <StyledDataGrid
                                            rows={filteredData.o || []} // o = one-time charges
                                            columns={oneTimeChargesColumns}
                                            pageSize={expandedTable === 'oneTime' ? 20 : 5}
                                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                            style={{ height: expandedTable === 'oneTime' ? '75vh' : '60vh' }}
                                            rowHeight={46}
                                            disableRowSelectionOnClick
                                            components={{ Toolbar: GridToolbar }}
                                        />
                                    </div>
                                </div>
                                )}

                                {/* =================== Payments =================== */}
                                {isTableVisible('payments') && (
                                <div className={`${cs.section} ${cs.sectionWide}`}>
                                    <div className={cs.sectionHeader}>
                                        <div className={cs.sectionTitleGroup}>
                                            <h3 className={cs.sectionTitle}>{t('Acceptances')}</h3>
                                            {client?.leadingBusiness && ['closed', 'open', 'all'].includes(paymentStatusFilter) && (
                                                <span className={cs.sectionFilterTag}>
                                                    ({paymentStatusFilter === 'closed' ? t('Closed') : paymentStatusFilter === 'open' ? t('Open') : t('All')})
                                                </span>
                                            )}
                                            <span className={`${cs.totalPill} ${cs.totalCredit}`}>
                                                {t('Total')}
                                                <b>{beautifyNumber(summaryTotals.payments)}</b>
                                            </span>
                                        </div>
                                        <div className={cs.sectionActions}>
                                            <XBtn
                                                variant="excel"
                                                onClick={handleDownloadPaymentsExcel}
                                                disabled={downloadingPaymentsExcel || !(filteredData.p || []).length}
                                                loading={downloadingPaymentsExcel}
                                                icon={<DownloadIconMui />}
                                            >
                                                {t('ExportToExcel', { defaultValue: 'ייצוא לאקסל' })}
                                            </XBtn>
                                            {!(client?.leadingBusiness && paymentActionMode && pickedPayments.length > 0) && (
                                                <XBtn
                                                    variant="primary"
                                                    onClick={() => handleOpenDialog('payments')}
                                                    icon={<AddCircleIcon />}
                                                >
                                                    {t('Add')}
                                                </XBtn>
                                            )}
                                            <ExpandToggle
                                                t={t}
                                                expanded={expandedTable === 'payments'}
                                                onClick={() => toggleExpandedTable('payments')}
                                            />
                                        </div>
                                    </div>
                                        {/* Payment action buttons: only when client is leading business */}
                                        {client?.leadingBusiness && (
                                        <div className={cs.actionsBar}>
                                            {paymentStatusFilter === 'open' && (
                                                <XBtn
                                                    onClick={() => {
                                                        setPaymentStatusFilter('closed');
                                                        setPaymentActionMode(null);
                                                        setPickedPayments([]);
                                                    }}
                                                >
                                                    {t('ViewClosedPayments')}
                                                </XBtn>
                                            )}
                                            {paymentStatusFilter === 'closed' && (
                                                <>
                                                    <XBtn
                                                        onClick={() => {
                                                            setPaymentStatusFilter('open');
                                                            setPaymentActionMode(null);
                                                            setPickedPayments([]);
                                                        }}
                                                    >
                                                        {t('openPayments')}
                                                    </XBtn>
                                                    <XBtn
                                                        active={paymentActionMode === 'reopen'}
                                                        onClick={() => {
                                                            setPaymentActionMode(prev => prev === 'reopen' ? null : 'reopen');
                                                            setPickedPayments([]);
                                                        }}
                                                    >
                                                        {t('OpenPayments')}
                                                    </XBtn>
                                                </>
                                            )}
                                            {(paymentStatusFilter === 'open' || paymentStatusFilter === 'all') && (
                                                <>
                                                    <XBtn
                                                        active={paymentActionMode === 'receipt'}
                                                        onClick={() => {
                                                            setPaymentActionMode(prev => prev === 'receipt' ? null : 'receipt');
                                                            setPickedPayments([]);
                                                        }}
                                                    >
                                                        {t('GenerateReceipts')}
                                                    </XBtn>
                                                    <XBtn
                                                        active={paymentActionMode === 'invoice'}
                                                        onClick={() => {
                                                            setPaymentActionMode(prev => prev === 'invoice' ? null : 'invoice');
                                                            setPickedPayments([]);
                                                        }}
                                                    >
                                                        {t('GenerateInvoices')}
                                                    </XBtn>
                                                    <XBtn
                                                        active={paymentActionMode === 'close'}
                                                        onClick={() => {
                                                            setPaymentActionMode(prev => prev === 'close' ? null : 'close');
                                                            setPickedPayments([]);
                                                        }}
                                                    >
                                                        {t('ClosePayments')}
                                                    </XBtn>
                                                </>
                                            )}
                                            {paymentActionMode && pickedPayments.length > 0 && (
                                                <span className={cs.actionsBarLabel}>
                                                    {t('Selected') + ': ' + pickedPayments.length}
                                                </span>
                                            )}
                                        {paymentActionMode && pickedPayments.length > 0 && (
                                            <>
                                                <div className={cs.actionsSpacer} />
                                                {paymentActionMode === 'receipt' && (
                                                    <>
                                                        <XBtn
                                                            variant="success"
                                                            onClick={() => handleGenerateReceiptsDraft()}
                                                            disabled={isGenerating || isGeneratingReceipts || isDraftingReceiptDrafts || isDraftingLedgerInvoices || pickedPayments.length < 1}
                                                            loading={isGenerating || isGeneratingReceipts || isDraftingReceiptDrafts}
                                                        >
                                                            {isDraftingReceiptDrafts || isGenerating || isGeneratingReceipts ? t('Generating') : t('GenerateReceipt')}
                                                        </XBtn>
                                                    </>
                                                )}
                                                {paymentActionMode === 'invoice' && (
                                                    <>
                                                        <XBtn
                                                            variant="orange"
                                                            onClick={async () => {
                                                                const defaultDate = (invoiceGenDate || new Date());
                                                                const dateStr = defaultDate instanceof Date ? defaultDate.toISOString().split('T')[0] : defaultDate;
                                                                const result = await Swal.fire({
                                                                    title: t('GenerateInvoices'),
                                                                    html: `
                                                                        <div  style="box-sizing: border-box !important; width: 100%; max-width: 100%; padding: 0; margin: 0; text-align: center;">
                                                                            <p style="margin: 0 0 8px 0; box-sizing: border-box; text-align: center;">${t('GenerateInvoiceForDate')}</p>
                                                                            <label class="invoice-use-payment-date" style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-bottom: 8px; cursor: pointer; box-sizing: border-box !important;">
                                                                                <span style="flex: 1; text-align: center;">${t('UsePaymentDateAsDocumentDate')}</span>
                                                                                <input type="checkbox" id="invoice-use-payment-date" style="width: 18px; height: 18px; flex-shrink: 0; margin: 0; box-sizing: border-box;">
                                                                            </label>
                                                                            <div id="invoice-date-section" style="margin-top: 8px; box-sizing: border-box !important;">
                                                                                <label for="invoice-date" style="display: block; margin-bottom: 4px; font-weight: bold; box-sizing: border-box;">${t('Date')}:</label>
                                                                                <input type="date" id="invoice-date" class="swal2-input" style="width: 100%; max-width: 100%; box-sizing: border-box !important; " value="${dateStr}">
                                                                            </div>
                                                                            <p id="invoice-use-payment-message" style="display: none; margin: 8px 0 0 0; padding: 8px; font-size: 0.9em; color: #555; box-sizing: border-box; text-align: center;"></p>
                                                                        </div>
                                                                    `,
                                                                    showCancelButton: true,
                                                                    confirmButtonText: t('Yes'),
                                                                    cancelButtonText: t('Cancel'),
                                                                    didOpen: () => {
                                                                        const content = document.querySelector('.invoice-date-modal-content');
                                                                        if (content) content.style.boxSizing = 'border-box';
                                                                        const usePaymentDate = document.getElementById('invoice-use-payment-date');
                                                                        const dateSection = document.getElementById('invoice-date-section');
                                                                        const messageEl = document.getElementById('invoice-use-payment-message');
                                                                        const dateInput = document.getElementById('invoice-date');
                                                                        const updateVisibility = () => {
                                                                            const checked = usePaymentDate?.checked;
                                                                            if (dateSection) dateSection.style.display = checked ? 'none' : 'block';
                                                                            if (messageEl) {
                                                                                messageEl.style.display = checked ? 'block' : 'none';
                                                                                messageEl.textContent = checked ? t('InvoiceWillUsePaymentDateMessage') : '';
                                                                            }
                                                                            if (dateInput) dateInput.disabled = !!checked;
                                                                        };
                                                                        if (usePaymentDate) {
                                                                            usePaymentDate.addEventListener('change', updateVisibility);
                                                                            updateVisibility();
                                                                        }
                                                                    },
                                                                    preConfirm: () => {
                                                                        const usePaymentDate = document.getElementById('invoice-use-payment-date');
                                                                        if (usePaymentDate?.checked) return null;
                                                                        const dateInput = document.getElementById('invoice-date');
                                                                        const selected = dateInput?.value;
                                                                        if (!selected) {
                                                                            Swal.showValidationMessage(t('PleaseSelectADate'));
                                                                            return false;
                                                                        }
                                                                        return selected;
                                                                    }
                                                                });
                                                                if (result.isConfirmed) {
                                                                    const selectedDate = result.value;
                                                                    if (selectedDate) setInvoiceGenDate(selectedDate);
                                                                    runWithSigRefCheck({ act: 'invoiceDraft', invoiceDate: selectedDate ?? null });
                                                                }
                                                            }}
                                                            disabled={isGenerating || isGeneratingReceipts || isDraftingLedgerInvoices || isDraftingReceiptDrafts}
                                                            loading={isDraftingLedgerInvoices || isGenerating}
                                                        >
                                                            {isDraftingLedgerInvoices
                                                                ? t('CreatingInvoiceDraft')
                                                                : isGenerating
                                                                  ? t('Generating')
                                                                  : t('GenerateInvoices')}
                                                        </XBtn>
                                                    </>
                                                )}
                                                {paymentActionMode === 'close' && (
                                                    <XBtn
                                                        variant="success"
                                                        onClick={handleCloseSelectedPayments}
                                                        disabled={isClosing}
                                                        loading={isClosing}
                                                    >
                                                        {isClosing ? t('Processing') : t('ClosePayments')}
                                                    </XBtn>
                                                )}
                                                {paymentActionMode === 'reopen' && (
                                                    <XBtn
                                                        variant="success"
                                                        onClick={handleOpenSelectedPayments}
                                                        disabled={isClosing}
                                                        loading={isClosing}
                                                    >
                                                        {isClosing ? t('Processing') : t('OpenPayments')}
                                                    </XBtn>
                                                )}
                                                <XBtn onClick={() => { setPaymentActionMode(null); setPickedPayments([]); }}>
                                                    {t('Cancel')}
                                                </XBtn>
                                            </>
                                        )}
                                        </div>
                                        )}
                                    <div className={cs.gridWrap}>
                                    <StyledDataGrid
                                        rows={filteredData.p || []} // show all payments including canceled; totals exclude canceled
                                        columns={paymentsColumns}
                                        pageSize={expandedTable === 'payments' ? 20 : 5}
                                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                        style={{ height: expandedTable === 'payments' ? '75vh' : '60vh' }}
                                        rowHeight={46}
                                        disableRowSelectionOnClick
                                        components={{ Toolbar: GridToolbar }}
                                        getRowClassName={(params) => {
                                            const canceled = params.row.invoiceIsCanceled || params.row.receiptIsCanceled || params.row.isCanceledManually;
                                            const amountPositive = Number(params.row.amount) > 0;
                                            if (canceled && amountPositive) return 'row-canceled-pulse';
                                            if (canceled) return 'row-canceled';
                                            if (params.row.invoiceId) return 'invoice-generated';
                                            if (params.row.receiptId) return 'receipt-generated';
                                            return '';
                                        }}
                                    />
                                    </div>
                                    <Menu
                                        anchorEl={paymentMenuAnchor}
                                        open={paymentActionMenuOpen}
                                        onClose={() => { setPaymentMenuAnchor(null); setPaymentMenuRow(null); }}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    >
                                        {paymentMenuRow && (
                                            !(paymentMenuRow.invoiceId || paymentMenuRow.receiptId) ||
                                            (paymentMenuRow.invoiceIsCanceled || paymentMenuRow.receiptIsCanceled || paymentMenuRow.isCanceledManually)
                                        ) && (
                                            <MenuItem onClick={() => handleDeletePaymentRow(paymentMenuRow)}>
                                                {t('DeletePayment')}
                                            </MenuItem>
                                        )}
                                        <MenuItem onClick={() => paymentMenuRow && handleCancelPaymentManually(paymentMenuRow)}>
                                            {t('CancelManually')}
                                        </MenuItem>
                                        {/* {paymentMenuRow && (paymentMenuRow.invoiceIsCanceled || paymentMenuRow.receiptIsCanceled || paymentMenuRow.isCanceledManually) && Number(paymentMenuRow.amount) > 0 && (
                                            <MenuItem onClick={() => handleSetPaymentAmountNegative(paymentMenuRow)}>
                                                {t('MakeAmountNegative')}
                                            </MenuItem>
                                        )} */}
                                    </Menu>
                                </div>
                                )}
                            </div>
                        </Box>

                        {/* dialog, loaders, etc. remain unchanged */}
                        <AddNewCollectionItem
                            isOpen={dialogOpen}
                            onClose={handleCloseDialog}
                            t={t}
                            newItem={newItem}
                            handleInputChange={handleInputChange}
                            handleAddItem={handleAddItem}
                            handleEditItem={handleEditItem}
                            itemType={itemType}
                            isEditMode={isEditMode}
                            handleDeleteItem={handleClickedDelete}
                            leadingBusiness={client?.leadingBusiness}
                            clientOptions={caseIdOptions}
                            viewInvoice={openInvoiceOfPayment}
                            viewReceipt={openRecieptOfPayment}
                            onDeletePayment={client?.leadingBusiness ? (row) => handleDeletePaymentRow(row, { fromModal: true }) : null}
                            onCancelPaymentManually={client?.leadingBusiness ? (row) => handleCancelPaymentManually(row, { fromModal: true }) : null}
                            onSetPaymentAmountNegative={client?.leadingBusiness ? (row) => handleSetPaymentAmountNegative(row, { fromModal: true }) : null}
                        />
                    </div>

                </>
                {/* <HamburgerMenu client={client} /> */}

                <ToastContainer />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader size={100} loading={loading} />
                    </div>
                )}

                {/* Ledger Reports Modal */}
                <LedgerReportsModal
                    visible={ledgerReportsModalOpen}
                    onClose={() => setLedgerReportsModalOpen(false)}
                    client={client}
                    isLeadingBusiness={client?.leadingBusiness}
                    selectedClient={selectedCaseIds.length === 1 ? selectedCaseIds[0] : null}
                />

                {/* Document Generation Logs Modal (receipts / invoices / MASAV runs + per-client outcomes) */}
                <DocumentGenerationLogsModal
                    open={generationLogsModalOpen}
                    onClose={() => setGenerationLogsModalOpen(false)}
                    caseId={leadingBusinessCaseId || client?.caseId}
                    t={t}
                    direction={direction}
                    subAccountantOptions={subAccountantOptions}
                    token={token}
                />

                {/* Payments Excel Import Modal (upload -> preview -> import) */}
                <PaymentsExcelImportModal
                    open={paymentsExcelImportModalOpen}
                    onClose={() => setPaymentsExcelImportModalOpen(false)}
                    clientOptions={caseIdOptions}
                    leadingBusiness={!!client?.leadingBusiness}
                    defaultCaseId={client?.caseId}
                    isImporting={loading}
                    onImport={handleExcelImportPayments}
                />

                {/* Monthly Charges Excel Import Modal (template -> upload -> preview -> commit) */}
                <MonthlyChargesExcelImportModal
                    open={monthlyChargesImportModalOpen}
                    onClose={() => setMonthlyChargesImportModalOpen(false)}
                    accountantId={client?.accountantId}
                    token={token}
                    clientOptions={caseIdOptions}
                    defaultCaseId={client?.leadingBusiness ? '' : client?.caseId}
                    onImported={handleMonthlyChargesImported}
                />

                <MasavDraftModal
                    direction={direction}
                    visible={masavDraftModalOpen}
                    onClose={() => setMasavDraftModalOpen(false)}
                    client={client}
                    filterCaseIds={masavFilterCaseIds}
                    draftReloadNonce={masavDraftReloadNonce}
                    onOpenMasavProfileSettings={handleOpenMasavProfileSettingsFromDraft}
                    onOpenBulkReceiptForSelection={(rows, context) => {
                        setMasavBatchContext(context?.batchId ? { batchId: context.batchId } : null);
                        setMasavBulkReceiptRows(rows);
                        setMasavBulkReceiptOpen(true);
                    }}
                    onOpenSavedCards={() => {
                        setSavedCardsForceCaseId(null);
                        setSavedCardsModalOpen(true);
                    }}
                    onMasavClientsChanged={() => setMasavDraftReloadNonce((n) => n + 1)}
                    token={token}
                />

                <PaymentArrangementsModal
                    open={paymentArrangementsModalOpen}
                    onClose={() => setPaymentArrangementsModalOpen(false)}
                    accountantId={client?.accountantId}
                    direction={direction}
                    filterCaseIds={masavFilterCaseIds}
                    onChanged={() => setMasavDraftReloadNonce((n) => n + 1)}
                />

                <MasavBulkReceiptModal
                    open={masavBulkReceiptOpen}
                    onClose={() => {
                        if (!masavBulkReceiptSubmitting) {
                            setMasavBulkReceiptOpen(false);
                            setMasavBulkReceiptRows([]);
                            setMasavCcChargeProgress({});
                            setMasavBatchContext(null);
                        }
                    }}
                    selectedRows={masavBulkReceiptRows}
                    direction={direction}
                    submitting={masavBulkReceiptSubmitting}
                    onSubmit={handleMasavBulkReceiptSubmit}
                    enableCreditCard={false}
                    defaultDescription={'נוצר על ידי מסב'}
                    chargeProgress={masavCcChargeProgress}
                    onOpenSavedCardsFor={(caseId) => {
                        setSavedCardsForceCaseId(caseId);
                        setSavedCardsModalOpen(true);
                    }}
                />

                <SavedCardsModal
                    open={savedCardsModalOpen && creditTerminalApproved}
                    onClose={() => setSavedCardsModalOpen(false)}
                    client={savedCardsForceCaseId
                        ? { caseId: savedCardsForceCaseId }
                        : client}
                    leadingBusiness={savedCardsForceCaseId ? false : !!client?.leadingBusiness}
                    direction={direction}
                    onChanged={() => setMasavDraftReloadNonce((n) => n + 1)}
                    supportsRawPan={creditTerminalStatus?.capabilities?.supportsRawPanDebit !== false}
                    terminalProviderCode={creditTerminalStatus?.providerCode ?? null}
                />

                <CreditCardBulkChargeModal
                    open={creditCardChargeOpen && creditTerminalApproved}
                    onClose={() => setCreditCardChargeOpen(false)}
                    direction={direction}
                    leadingBusiness={!!client?.leadingBusiness}
                    client={client}
                    filterCaseIds={masavFilterCaseIds}
                    terminalProviderCode={creditTerminalStatus?.providerCode ?? null}
                    onOpenSavedCardsFor={(caseId) => {
                        setSavedCardsForceCaseId(caseId || null);
                        setSavedCardsModalOpen(true);
                    }}
                    onChargeFinished={() => {
                        fetchEnums(null, token, client, null, null);
                        setMasavDraftReloadNonce((n) => n + 1);
                    }}
                />

                <MasavAccountantSettingsModal
                    open={masavProfileModalOpen}
                    onClose={handleMasavProfileModalClose}
                    user={user}
                    token={token}
                    direction={direction}
                    onSaved={handleMasavProfileSaved}
                />

                <TaxAuthorityErrorModal
                    open={isTaxAuthorityErrorModalVisible}
                    onClose={() => setIsTaxAuthorityErrorModalVisible(false)}
                    onOptionSelect={handleTaxAuthorityOptionSelect}
                    invoiceData={null}
                    caseId={client?.caseId}
                    token={token}
                />
            </>

        </>
    );
}


export default CollectionPage;
